import { Component, ViewChild, AfterViewInit, OnInit, Inject, ElementRef } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpParams, HttpResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
//import { MomentModule } from 'angular2-moment';
//import { MomentTimezoneModule } from 'angular-moment-timezone';

import { ContractService } from '../services/contract-service';
import { MasterService } from '../services/master-service';
import { MachineService } from '../services/machine-service';
import { SupportService } from '../services/support-service';
import { AuthService } from '../services/auth.service';
import { ReportService } from '../services/report-service';
import { CommonService } from '../services/common-service';

//grid
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxDropDownListComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownlist';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxWindowComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxwindow';
import { jqxEditorComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxeditor';
import { jqxRadioButtonComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxradiobutton';
import { jqxLoaderComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxloader';

import { Observable } from 'rxjs/Observable';
import { last, forEach } from '@angular/router/src/utils/collection';
import { validateConfig } from '@angular/router/src/config';
import { jqxCheckBoxComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxcheckbox';

@Component({
  //selector: 'app-root',
  templateUrl: './contract-list.component.html',
  //styleUrls: ['./contract-list.component.css'],
  //providers: [ContractService]
})

export class ContractListComponent implements OnInit {
  @ViewChild('myGrid') myGrid: jqxGridComponent;
  @ViewChild('findDropDownList') findDropDownList: jqxDropDownListComponent;
  @ViewChild('monthDropDownList') monthDropDownList: jqxDropDownListComponent;
  @ViewChild('yearDropDownList') yearDropDownList: jqxDropDownListComponent;
  @ViewChild('mailDropDownList') mailDropDownList: jqxDropDownListComponent;
  @ViewChild('myInput') myInput: jqxInputComponent;
  @ViewChild('myWindow') myWindow: jqxWindowComponent;
  @ViewChild('MyLoader') MyLoader: jqxLoaderComponent;

  @ViewChild('startMonth') startMonth: jqxRadioButtonComponent;
  @ViewChild('betweenMonth') betweenMonth: jqxRadioButtonComponent;
  @ViewChild('endMonth') endMonth: jqxRadioButtonComponent;

  @ViewChild('srchClient') srchClient: jqxInputComponent;
  @ViewChild('srchMAC') srchMAC: jqxInputComponent;
  @ViewChild('srchEmail') srchEmail: jqxInputComponent;
  //public rowscount = 0;

  errorMessage: any;
  month: string = '0';
  year: string = '0';
  email_type_id: number = 0;
  contract_type_id: number = 0;
  paid_flg_id: number = 2;// 0:Unpaid, 1:Paid, 2:All
  month_flg_id: number = 0;// 0:start, 1:between, 2:end
  isShowAll: boolean = true;
  //first_flg: boolean = true;
  loading_flg: boolean = false;
  srch_Client: string = '';
  srch_MAC: string = '';
  srch_Email: string = '';

  //pre_contract_type_id: number = 0;
  //pre_paid_flg_id: number = 2;
  //pre_month_flg_id: number = 0;
  //month_is_first: boolean = true;
  
  //get grid source
  constructor(
    private _contractService: ContractService, private _router: Router, private _reportService: ReportService, private _com: CommonService,
    //private _moment: MomentModule, private _timezone: MomentTimezoneModule,
    public dialog: MatDialog) {
  }

  ngOnInit() {
    this.month = this.getMonth();
    this.year = this.getYear();
  }

  ngAfterViewInit(): void {
    this.createButtons();
    this.monthDropDownList.setOptions({ disabled: this.isShowAll });
    this.yearDropDownList.setOptions({ disabled: this.isShowAll });
    this.startMonth.setOptions({ disabled: this.isShowAll });
    this.betweenMonth.setOptions({ disabled: this.isShowAll });
    this.endMonth.setOptions({ disabled: this.isShowAll });
  }

  //get grid source
  getContractPeriods() {
    this.loading_flg = true;
    //if (!(this.first_flg)) {
      this.MyLoader.open();
    //}

    this._contractService.getContractPeriods(((this.isShowAll) ? '0' : this.month), ((this.isShowAll) ? '0' : this.year), this.month_flg_id, this.srch_Client, this.srch_MAC, this.srch_Email)
      .subscribe((data) => {
        if (this.email_type_id != 0) {
          data = data.filter(p => p.email_type_id == this.email_type_id);
        }
        if (this.contract_type_id != 0) {
          data = data.filter(p => p.contract_type_id == this.contract_type_id);
        }
        if (this.paid_flg_id != 2) {
          data = data.filter(p => p.paid_flg == Boolean(this.paid_flg_id));
        }
        this.source.localdata = data;
        //this.rowscount = data.length;
        this.dataAdapter.dataBind();
        //this.pre_month_flg_id == this.month_flg_id;
        //this.pre_paid_flg_id == this.paid_flg_id;
        //this.pre_contract_type_id == this.contract_type_id;
        //if (!(this.first_flg)) {
          this.MyLoader.close();
        //}
        //this.first_flg = false;
        this.loading_flg = false;
      });
    this.clearGridPopData();
  }

  //datetime now
  getMonth() {
    return (new Date()).getMonth().toString();
  }
  getYear() {
    let year = (new Date()).getFullYear() - 2000;
    return year.toString();
  }

  //grid width
  getWidth(): any {
    //if (document.body.offsetWidth < 800) {
    //  return '90%';
    //}
    return '100%';
  }

  //Dropdown find
  dropDownSource: string[] = ['Client', 'Agent', 'Contract Type', 'Machine', 'MAC', 'Order No', 'Payment', 'Satrt Date', 'End Date', 'Email', 'Phone', 'Days Left', 'Sent Date', 'Sent Mail', 'Status'];

  //Dropdown month
  dropDownMonth: number[] = this._com.getMonthDropDownList();

  //Dropdown year
  dropDownYear: number[] = this._com.getYearDropDownList();

  //grid source
  source: any =
    {
      datatype: 'json',
      datafields: [
        { name: 'contract_period_id', type: 'int' },
        { name: 'contract_id', type: 'int' },
        { name: 'device_id', type: 'int', map: 'contract>device_id' },
        { name: 'item_name', type: 'string', map: 'contract>m_plan>item_name' },
        { name: 'mac_address', type: 'string', map: 'contract>mac_address' },
        { name: 'order_no', type: 'string', map: 'contract>order_no' },
        { name: 'plan_type', type: 'string', map: 'contract>plan_type' },
        { name: 'agent_person_id', type: 'string', map: 'contract>agent_person_id' },
        { name: 'agent_person_name', type: 'string', map: 'contract>agent_person_name' },
        { name: 'start_date', type: 'date' },
        { name: 'end_date', type: 'date' },
        { name: 'customer_id', type: 'int', map: 'contract>customer_id' },
        { name: 'customer_name', type: 'string', map: 'contract>customer_name' },
        { name: 'customer_email', type: 'string', map: 'contract>customer_email' },
        { name: 'customer_phone', type: 'string', map: 'contract>customer_phone' },
        { name: 'paid_flg', type: 'bool' },
        { name: 'sent_email', type: 'date' },
        { name: 'email_type', type: 'string' },
        { name: 'contract_type', type: 'string' },
        { name: 'status_code', type: 'string', map: 'contract>status_code' },
        { name: 'days', type: 'int' }
      ],
      id: 'contract_period_id',
      localdata: {},
      sortcolumn: 'days',
      sortdirection: 'desc'
    };
  dataAdapter: any = new jqx.dataAdapter(this.source,
    {
      //Compute Days Left 2019/09/24 最新だけLeft Date付与
      //Compute Days Left 結局データで持たせる
      //beforeLoadComplete: function (records) {
      //  var today = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate());
      //  var pre_contract = 0;
      //  for (var i = 0; i < records.length; i++) {
      //    var end = new Date();
      //    if (records[i]['end_date'] != null && pre_contract != records[i]['contract_id']) {
      //      end = new Date(records[i]['end_date'].getFullYear(), records[i]['end_date'].getMonth(), records[i]['end_date'].getDate());
      //    } else {
      //      end = null;
      //    }

      //    if (end != null) {
      //      var days = Math.floor((Date.UTC(end.getFullYear(), end.getMonth(), end.getDate()) - Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())) / (1000 * 60 * 60 * 24));
      //      records[i]['days'] = days;
      //    } else {
      //      records[i]['days'] = null;
      //    }
      //    pre_contract = records[i]['contract_id'];
      //  }
      //}
    });

  //grid columns

  children: any;
  currentRow: any;
  callbackSourceEdit: Array<any> = [];
  callbackSourceEmail: Array<any> = [];
  cntEdit: number = 1;
  cntEmail: number = 1;
  counterEdit: number = 1;
  counterEmail: number = 1;
  clearGridPopData() {
    this.callbackSourceEdit = [];
    this.cntEdit = 1;
    this.counterEdit = 1;
    this.callbackSourceEmail = [];
    this.cntEmail = 1;
    this.counterEmail = 1;
  }
  //callbackSource: any =
  //  {
  //    datatype: 'array',
  //    datafields: [
  //      { name: 'id', type: 'int' },
  //      { name: 'currentRow', type: 'int' },
  //      { name: 'currentData', type: 'any' }
  //    ],
  //    localdata: {}
  //  };
  columns: any[] =
    [
      { text: 'Client', datafield: 'customer_name', width: '13%', columntype: 'textbox' },
      { text: 'Agent', datafield: 'agent_person_name', width: '10%', columntype: 'textbox', align: 'left', cellsalign: 'left' },
      { text: 'Contract Type', datafield: 'contract_type', width: '7%', columntype: 'textbox', align: 'left', cellsalign: 'left', editable: false },
      { text: 'Machine', datafield: 'item_name', width: '9%', columntype: 'textbox', align: 'left', cellsalign: 'left' },
      { text: 'MAC', datafield: 'mac_address', width: '9%', columntype: 'textbox', align: 'left', cellsalign: 'left' },
      //{ text: 'Order No', datafield: 'order_no', width: '5%', columntype: 'textbox' },
      { text: 'Payment', datafield: 'plan_type', width: '5%', columntype: 'textbox', align: 'left', cellsalign: 'left', editable: false },
      { text: 'Start Date', datafield: 'start_date', width: '6%', columntype: 'date', cellsformat: 'd', editable: false },
      { text: 'End Date', datafield: 'end_date', width: '6%', columntype: 'date', cellsformat: 'd', editable: false },
      //{ text: 'Email', datafield: 'customer_email', width: '11%', columntype: 'textbox' },
      {
        text: 'Email', datafield: 'customer_email', width: '7%', columntype: 'textbox', align: 'left', cellsalign: 'left',
        //buttonclick: function PassValue(row) {
        //  //var listener = function (e) {

        //  //  e.clipboardData.setData("text/plain", row);
        //  //  // 本来のイベントをキャンセル
        //  //  e.preventDefault();
        //  //  // 終わったら一応削除
        //  //  document.removeEventListener("copy", listener);
        //  //}

        //  // コピーのイベントが発生したときに、クリップボードに書き込むようにしておく
        //  document.addEventListener("copy", row);
        //  // コピー
        //  document.execCommand("copy");
        //}
      },
      { text: 'Phone', datafield: 'customer_phone', width: '6%', columntype: 'textbox', editable: false },
      { text: 'Paid', datafield: 'paid_flg', width: '4%', columntype: 'checkbox', twostatecheckbox: true, align: 'center', editable: false },
      {
        text: 'Days Left', datafield: 'days', width: '4%', columntype: 'textbox', align: 'center', cellsalign: 'center', editable: false
        //,
        //cellsrenderer: (index: number, datafield: string, value: any, defaultvalue: any, column: any, rowdata: any): string => {
        //  var today = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate());
        //  var end = new Date();
        //  if (rowdata.end_date != null) {
        //    end = new Date(rowdata.end_date.getFullYear(), rowdata.end_date.getMonth(), rowdata.end_date.getDate());
        //  }
        //  var days = Math.floor((Date.UTC(end.getFullYear(), end.getMonth(), end.getDate()) - Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())) / (1000 * 60 * 60 * 24));
        //  return '<div style="margin-top: 10px;" class="jqx-center-align">' + this.dataAdapter.formatNumber(days, 'number')  + '</div>';
        //}
      },
      {
        text: 'Sent Date', datafield: 'sent_email', width: '6%', columntype: 'datetimeinput', cellsformat: 'MM/dd/yyyy HH:mm:ss', editable: false
      },
      { text: 'Sent Mail', datafield: 'email_type', width: '6%', columntype: 'textbox', editable: false },
//      {
//        text: 'Mail', datafield: 'Send', width: '3%', align: 'center',
//        createwidget: (row, column: any, value: string, htmlElement: HTMLElement): void => {
//          let container = document.createElement('div');
//          let containerId = `sendEmail${this.counterEmail}`;
//          container.id = containerId;
//          container.style.cssText = 'margin: 10px;'
//          //container.style.border = 'none';
//          htmlElement.appendChild(container);
//
//          if (row.bounddata.contract_id != null) {
//            let options = {
//              //width: 80, height: 25,
//              theme: 'material',
//              template: 'success',
//              value: value,
//              textPosition: 'center',
//              imgSrc: '../../assets/img/email.ico'
//            };
//            let myButton = jqwidgets.createInstance(`#${containerId}`, 'jqxButton', options);
//            myButton.addEventHandler('click', (): void => {
//              //let rowid = this.myGrid.getrowid(row);
//              //const dataValue = this.myGrid.getrowdatabyid(rowid);
//              let dataValue = this.callbackSourceEmail.find(({ id }) => id === Number(containerId.replace("sendEmail", ""))).currentData;
//              let dialogRef = this.dialog.open(PopupEmailComponent, {
//                width: '1000px',
//                //height: 'auto*',
//                disableClose: true,//20191007 close無し
//                data: {
//                  contract_period_id: dataValue.contract_period_id,
//                  contract_id: dataValue.contract_id,
//                  customer_id: dataValue.customer_id,
//                  agent_id: dataValue.agent_person_id,
//                  customer_name: dataValue.customer_name,
//                  customer_email: dataValue.customer_email,
//                  start_date: dataValue.start_date,
//                  end_date: dataValue.end_date,
//                }
//              });
//              dialogRef.afterClosed().subscribe(
//                (result) => {
//                  //20191008 自分のタイミングで更新するように
//                  //this.getContractPeriods();
//                });
//            });
//          }
//          this.counterEmail++;
//        },
//        initwidget: (row: number, column: any, value: any, htmlElement: HTMLElement): void => {
//          //htmlElement.children[1].children[1].innerHTML = row.toString();
//          let rowid = this.myGrid.getrowid(row);
//
//          //htmlElement.children[0].innerHTML = row.toString();
//          if (typeof rowid !== 'undefined' && Number(rowid) !== 0) {
//            var callback = { id: this.cntEmail, currentRow: row, currentData: this.myGrid.getrowdatabyid(rowid) };
//            //console.log("currentData: " + callback.currentData + ", id:" + callback.id + ", row:" + callback.currentRow);
//
//            this.callbackSourceEmail.push(callback);
//          }
//          this.cntEmail++;
//        }
//      },
      ,
      { text: 'Status', datafield: 'status_code', width: '5%', columntype: 'textbox', editable: false },
      //{ text: 'Id', datafield: 'contract_id', width: '5%', columntype: 'textbox' },
      {
        text: 'Edit', datafield: 'edit', width: '3%', align: 'center', editable: false
        //cellsrenderer: function () {
        //  //return "Send";
        //  //return '<div style=”width: 100 %; ”<imag src=”../../assets/img/email.ico” style=”margin- left: -12px; margin - top: -12px; ” /></div >”';
        //  return '<div style=”width: 100 %; ”<imag src=”../../assets/img/email.ico”/></div >”';
        //},
        //createwidget: (row, column: any, value: string, htmlElement: HTMLElement): void => {
        //  let container = document.createElement('div');
        //  let containerId = `Edit${this.counterEdit}`;
        //  container.id = containerId;
        //  container.style.cssText = 'margin: 10px;'
        //  //container.style.border = 'none';
        //  htmlElement.appendChild(container);
        //
        //  if (row.bounddata.contract_id != null) {
        //    let options = {
        //      //width: 80, height: 25,
        //      theme: 'material',
        //      template: 'primary',
        //      value: value,
        //      textPosition: 'center',
        //      imgSrc: '../../assets/img/edit.ico',
        //      disabled: true,
        //    };
        //    let myButton = jqwidgets.createInstance(`#${containerId}`, 'jqxButton', options);
        //    //myButton.addEventHandler('click', (): void => {
        //    //  let dataValue = this.callbackSourceEdit.find(({ id }) => id === Number(containerId.replace("Edit", ""))).currentData;
        //    //  let dialogRef = this.dialog.open(PopupContractComponent, {
        //    //    width: '1000px',
        //    //    //height: 'auto*',
        //    //    disableClose: true,//20191007 close無し
        //    //    data: {
        //    //      contract_id: dataValue.contract_id,
        //    //      customer_id: dataValue.customer_id,
        //    //      device_id: dataValue.device_id,
        //    //      title: '(Edit/View)'
        //    //    }
        //    //  });
        //    //  dialogRef.afterClosed().subscribe(
        //    //    (result) => {
        //    //      //20191008 自分のタイミングで更新するように
        //    //      //this.getContractPeriods();
        //    //    });
        //    //});
        //  }
        //
        //  this.counterEdit++;
        //},
        //initwidget: (row: number, column: any, value: any, htmlElement: HTMLElement): void => {
        //  let rowid = this.myGrid.getrowid(row);
        //
        //  if (typeof rowid !== 'undefined' && Number(rowid) !== 0 ) {
        //    var callback = { id: this.cntEdit, currentRow: row, currentData: this.myGrid.getrowdatabyid(rowid) };
        //    //console.log("currentData: " + callback.currentData + ", id:" + callback.id + ", row:" + callback.currentRow);
        //
        //    this.callbackSourceEdit.push(callback);
        //  }
        //  this.cntEdit++;
        //}
      },
    ];

  ////2019/10/09 Paging時のデータ読込用　以下を追加
  //rendergridrows = (params: any): any[] => {
  //  let data = this.generateData(params.startindex, params.endindex);
  //  return data;
  //}
  ////2019/10/09 Paging時のデータ読込用　以下を追加
  //generateData(startindex: number, endindex: number): any {
  //  let data = {};
  //  if (typeof this.dataAdapter !== "undefined") {
  //    for (let i = startindex; i < endindex; i++) {
  //      //let row = 
  //      //let row = {};
  //      let contract = this.dataAdapter.records[i];
  //      //row['id'] = i;
  //      //row['contract_period_id'] = contract.contract_period_id;
  //      //row['contract_id'] = contract.contract_id;
  //      //row['device_id'] = contract.contract_id;
  //      //row['item_name'] = contract.item_name;
  //      //row['mac_address'] = contract.mac_address;
  //      //row['order_no'] = contract.order_no;
  //      //row['plan_type'] = contract.plan_type;
  //      //row['agent_person_id'] = contract.agent_person_id;
  //      //row['agent_person_name'] = contract.agent_person_name;
  //      //row['start_date'] = contract.start_date;
  //      //row['end_date'] = contract.end_date;
  //      //row['customer_id'] = contract.customer_id;
  //      //row['customer_name'] = contract.customer_name;
  //      //row['customer_email'] = contract.customer_email;
  //      //row['paid_flg'] = contract.paid_flg;
  //      //row['sent_email'] = contract.sent_email;
  //      //row['email_type'] = contract.email_type;
  //      //row['contract_type'] = contract.contract_type;
  //      //row['status_code'] = contract.status_code;
  //      //row['days'] = contract.days;
  //      data[i] = contract;
  //    }
  //  }
  //  return data;
  //}
  //group header highlight
  groupsrenderer(text, group, expanded, data): any {
    var color;
    switch (data.level) {
      case 0:
        color = '#B0BEC5';
        break;
      case 1:
        color = '#CFD8DC';
        break;
      case 2:
        color = '#ECEFF1';
        break;
      case 3:
        color = '#EEEEEE';
        break;
      case 4:
        color = '#F5F5F5';
        break;
      case 5:
        color = '#FAFAFA';
        break;
    }
    //return '<div style="width: 100%; height: 100%; background-color: ' + color + '; color:Black; line-height:30px;"><span style="font-weight:bold; vertical-align: middle;">' + text + '</span></div>';
    return '<div style="width: 100%; height: 100%; background-color: #CFD8DC; color:Black; line-height:30px;"><span style="font-weight:bold; vertical-align: middle;">' + text + '</span></div>';
  }

  //tool buttons
  createButtonsContainers(statusbar: any): void {
    let buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = 'overflow: hidden; position: relative; margin: 5px;';
    let reloadButtonContainer = document.createElement('div');
    //let searchButtonContainer = document.createElement('div');
    let createButtonContainer = document.createElement('div');
    reloadButtonContainer.id = 'reloadButton';
    //searchButtonContainer.id = 'searchButton';
    createButtonContainer.id = 'createButton';
    reloadButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //searchButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    createButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    reloadButtonContainer.className = 'btn btn-default';
    //searchButtonContainer.className = 'btn btn-default';
    createButtonContainer.className = 'btn btn-default';
    buttonsContainer.appendChild(reloadButtonContainer);
    //buttonsContainer.appendChild(searchButtonContainer);
    buttonsContainer.appendChild(createButtonContainer);
    statusbar[0].appendChild(buttonsContainer);
  }

  createButtons(): void {
    let reloadButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      template: "inverse",
      value: "<span class='glyphicon glyphicon-refresh' style='color:#3F51B5;' title='Reload'></span> "
    }
    let reloadButton = jqwidgets.createInstance('#reloadButton', 'jqxButton', reloadButtonOptions);
    //let searchButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  template: "inverse",
    //  value: "<span class='glyphicon glyphicon-search' style='color:#607D8B;' title='Find'></span> "
    //}
    //let searchButton = jqwidgets.createInstance('#searchButton', 'jqxButton', searchButtonOptions);
    let createButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      template: "inverse",
      value: "<span class='glyphicon glyphicon-plus' style='color:#388E3C;' title='Create'></span> "
    }
    let createButton = jqwidgets.createInstance('#createButton', 'jqxButton', createButtonOptions);

    // reload grid data.
    reloadButton.addEventHandler('click', (event: any): void => {
      this.getContractPeriods();
    });
    // search for a record.
    //searchButton.addEventHandler('click', (event: any): void => {
    //  this.myWindow.open();
    //  this.myWindow.move(60, 60);
    //});
    // create new record.
    createButton.addEventHandler('click', (event: any): void => {
      let id = 0;
      let dialogRef = this.dialog.open(PopupContractComponent, {
        width: '900px',
        height: 'auto',
        disableClose: true,//20191007 close無し
        data: {
          contract_id: id,
          title:'(Create)'
        }
      });
      dialogRef.afterClosed().subscribe(
        (result) => {
          //20191008 自分のタイミングで更新するように
          //this.getContractPeriods();
        });
    });
  }

  //find button
  findBtnOnClick(): void {
    this.myGrid.clearfilters();
    let searchColumnIndex = this.findDropDownList.selectedIndex();
    let datafield = '';
    switch (searchColumnIndex) {
      case 0:
        datafield = 'contract_id';
        break;
      case 2:
        datafield = 'item_name';
        break;
      case 3:
        datafield = 'mac_address';
        break;
      case 4:
        datafield = 'order_no';
        break;
      case 5:
        datafield = 'plan_type';
        break;
      case 6:
        datafield = 'start_date';
        break;
      case 7:
        datafield = 'end_date';
        break;
      case 8:
        datafield = 'customer_name';
        break;
      case 9:
        datafield = 'customer_email';
        break;
      case 10:
        datafield = 'customer_phone';
        break;
      case 11:
        datafield = 'days';
        break;
      case 12:
        datafield = 'sent_email';
        break;
      case 13:
        datafield = 'email_type';
        break;
      case 14:
        datafield = 'status_code';
        break;
    }
    let searchText = this.myInput.val();
    let filtergroup = new jqx.filter();
    let filter_or_operator = 1;
    let filtervalue = searchText;
    let filtercondition = 'contains';
    let filter = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
    filtergroup.addfilter(filter_or_operator, filter);
    this.myGrid.addfilter(datafield, filtergroup);
    // apply the filters.
    this.myGrid.applyfilters();
  }

  clearBtnOnClick(): void {
    this.myGrid.clearfilters();
  }

  //Popup
  Rowdoubleclick(event: any): void {
    let selectedrowindex = this.myGrid.getselectedrowindex();
    let contractId = this.myGrid.getrowdata(selectedrowindex).contract_id;
    let deviceId = this.myGrid.getrowdata(selectedrowindex).device_id;
    let customerId = this.myGrid.getrowdata(selectedrowindex).customer_id;
    //let agentId = this.myGrid.getrowdata(selectedrowindex).agent_id;
    let dialogRef = this.dialog.open(PopupContractComponent, {
      width: '1000px',
      //height: 'auto*',
      disableClose: true,//20191007 close無し
      data: {
        contract_id: contractId,
        device_id: deviceId,
        customer_id: customerId,
        //agent_id: agentId,
        title:'(Edit/View)'
      }
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        //20191008 自分のタイミングで更新するように
        //this.getContractPeriods();
      });
  }

  //Filtering
  monthOnSelect(event: any): void {
    let args = event.args;
    let item = this.monthDropDownList.getItem(args.index);
    if (item != null) {
      this.month = this.monthDropDownList.getSelectedIndex().toString();
      //this.getContractPeriods();
    }
  };
  yearOnSelect(event: any): void {
    let args = event.args;
    let item = this.yearDropDownList.getItem(args.index);
    if (item != null) {
      this.year = this.yearDropDownList.getSelectedIndex().toString();
      //this.getContractPeriods();
    }
  };
  periodCheckBoxOnChange(event: any): void {
    let args = event.args;
    this.isShowAll = args.checked;
    if (args.checked == true) {
      this.month = '0';
      this.year = '0';
      this.betweenMonth.setOptions({ checked: !(this.isShowAll) });
      this.endMonth.setOptions({ checked: !(this.isShowAll) });
      this.startMonth.setOptions({ checked: this.isShowAll });
      this.month_flg_id = 0;
    }
    else {
      this.month = this.monthDropDownList.getSelectedIndex().toString();
      this.year = this.yearDropDownList.getSelectedIndex().toString();
    }
    this.monthDropDownList.setOptions({ disabled: this.isShowAll });
    this.yearDropDownList.setOptions({ disabled: this.isShowAll });
    //this.getContractPeriods();
    this.startMonth.setOptions({ disabled: this.isShowAll });
    this.betweenMonth.setOptions({ disabled: this.isShowAll });
    this.endMonth.setOptions({ disabled: this.isShowAll });
  };

  //Target Month status
  startBtnOnClick(event: any): void {
    this.monthBtnSetValue(0);
  }
  betweenBtnOnClick(event: any): void {
    this.monthBtnSetValue(1);
  }
  endBtnOnClick(event: any): void {
    this.monthBtnSetValue(2);
  }

  monthBtnSetValue(code) {
    if (!(this.isShowAll)) {
      this.month_flg_id = code;
      //this.getContractPeriods();
    }
  }

  //paid status
  paidBtnOnClick(event: any): void {
    this.paidBtnSetValue(1);
  }
  unpaidBtnOnClick(event: any): void {
    this.paidBtnSetValue(0);
  }
  paidallBtnOnClick(event: any): void {
    this.paidBtnSetValue(2);
  }

  paidBtnSetValue(code) {
    this.paid_flg_id = code;
    //this.getContractPeriods();
  }

  //contract type
  firstBtnOnClick(event: any): void {
    this.typeBtnSetValue(1);
  }
  secondBtnOnClick(event: any): void {
    this.typeBtnSetValue(2);
  }
  thirdBtnOnClick(event: any): void {
    this.typeBtnSetValue(3);
  }
  fourthBtnOnClick(event: any): void {
    this.typeBtnSetValue(0);
  }
  //fifthBtnOnClick(event: any): void {
  //  this.typeBtnSetValue(5);
  //}

  typeBtnSetValue(code) {
    this.contract_type_id = code;
    //this.getContractPeriods();     
  }

  onPageChanged(): void {
    this.clearGridPopData();
    this.myGrid.expandallgroups();
  }

  searchBtnOnClick() {
    this.getContractPeriods();
  };

  emailBtnOnClick() {
    let selectedrowindex = this.myGrid.getselectedrowindex();
    let contractPeriodId = this.myGrid.getrowdata(selectedrowindex).contract_period_id;
    let contractId = this.myGrid.getrowdata(selectedrowindex).contract_id;
    let deviceId = this.myGrid.getrowdata(selectedrowindex).device_id;
    let customerId = this.myGrid.getrowdata(selectedrowindex).customer_id;
    let agentId = this.myGrid.getrowdata(selectedrowindex).agent_person_id;
    let customerName = this.myGrid.getrowdata(selectedrowindex).customer_name;
    let customerEmail = this.myGrid.getrowdata(selectedrowindex).customer_email;
    let customerPhone = this.myGrid.getrowdata(selectedrowindex).customer_phone;
    let startDate = this.myGrid.getrowdata(selectedrowindex).start_date;
    let endDate = this.myGrid.getrowdata(selectedrowindex).end_date;


    let dialogRef = this.dialog.open(PopupEmailComponent, {
      width: '1500px',
      //height: 'auto*',
      disableClose: true,//20191007 close無し
      data: {
        contract_period_id: contractPeriodId,
        contract_id: contractId,
        customer_id: customerId,
        agent_id: agentId,
        customer_name: customerName,
        customer_email: customerEmail,
        customer_phone: customerPhone,
        start_date: startDate,
        end_date: endDate,
      }
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        //20191008 自分のタイミングで更新するように
        //this.getContractPeriods();
      });
  };

  //print pdf
  printBtnOnClick() {
    this._reportService.showPrint(this.myGrid, 'Contract');
  };

  //export excel
  excelBtnOnClick() {
    this._reportService.exportExcel(this.myGrid, 'Contract');
  };
}

//**************************************************************************************************************
// PopUp Contract
//**************************************************************************************************************
@Component({
  selector: 'app-popup-contract',
  templateUrl: 'popup-contract.component.html',
  styleUrls: ['./popup-contract.component.css'],
  //providers: [ContractService]
})
export class PopupContractComponent implements OnInit {
  @ViewChild('contractGrid') contractGrid: jqxGridComponent;
  @ViewChild('supportGrid') supportGrid: jqxGridComponent;
  @ViewChild('machineGrid') machineGrid: jqxGridComponent;
  @ViewChild('editorSupport') myEditor: jqxEditorComponent;
  user: any;
  title: string;
  contractForm: FormGroup;
  supportForm: FormGroup;
  errorMessage: any;
  successMessage: any;

  contractSelectedcell: any;
  supportSelectedcell: any;
  machineSelectedcell: any;
  contractDelrows: Array<any> = [];
  supportDelrows: Array<any> = [];
  machineDelrows: Array<any> = [];

  planList: Array<any> = [];
  paymentList: Array<any> = [];
  deviceList: Array<any> = [];
  deviceSearchedList: Array<any> = [];
  //agentList: Array<any> = [];
  //agentSearchedList: Array<any> = [];
  agentPersonSearchedList: Array<any> = [];
  agentPersonList: Array<any> = [];
  customerList: Array<any> = [];
  customerSearchedList: Array<any> = [];
  statusList: Array<any> = [];

  holderEmail: string = "Email";
  holderPhone: string = "Phone";
  holderAddress: string = "Address";

  public pre_end_date: any;
  //public warrantyStr: string;
  
  public isOpenSupport: boolean;
  //public IsDisable: boolean;

  public new_customer_flg: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PopupContractComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _contractService: ContractService,
    private _masterService: MasterService,
    private _machineService: MachineService,
    private _supportService: SupportService,
    private _authService: AuthService,
    private _fb: FormBuilder, private _com: CommonService
  ) {
    this.title = data.title;
    //this.IsDisable = (data.title == "(Create)") ? false : true;
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.user = this._authService.getAuthLoginName();
    this.contractForm = this._fb.group({
      contract_id: 0,
      device_id: [0, Validators.required],
      mac_address: ['', Validators.required],
      plan_id: [11, Validators.required],
      plan_type: ['未定', Validators.required],
      m_plan: '',
      payment_id: [1, Validators.required],
      payment_name: ['一括', Validators.required],
      order_no: '',
      customer_id: [0, Validators.required],
      customer_name: ['', Validators.required],
      //customer_state: '',
      //customer_city: '',
      customer_address: '',
      customer_email: '',
      customer_phone: '',
      //agent_id: 0,
      //agent_name: '',
      agent_person_id: 0,
      agent_person_name: '',
      commission: null,
      payment_code: '',
      m_status: '',
      status_id: 0,
      status_code: '',
      updated_by: this.user,
      updated_date: todayStr
    })
    this.supportForm = this._fb.group({
      support_id: 0,
      supported: todayStr,
      customer_id: 0,
      customer_name: ['', Validators.required],
      device_id: 0,
      mac_address: ['', Validators.required],
      symptom_id: 0,
      symptom_name: ['', Validators.required],
      support_contents: ''
    })
  }

  ngOnInit() {
    //this.getContractById(this.data.contract_id);
    this.getDropDownList();
    this.getContractById(this.data.contract_id);
    this.getContractPeriodsByContract(this.data.contract_id);
    this.getMachinesByDeviceId(this.data.device_id);
    //this.getDeviceById(this.data.device_id)
    this.getSupportsForContract(this.data.customer_id, this.data.device_id);
    this.getSymptoms(true);
    //this.changeNewCustomer(this.new_customer_flg);
  }

  ngAfterViewInit(): void {
    this.contractCreateButtons();
    this.supportCreateButtons();
    this.machineCreateButtons();
  }

  getContractById(id) {
    if (id > 0) {
      this.title = '(Edit/View)';
      this._contractService.getContractById(id)
        .subscribe(
          //res => this.contract = res
          res => {
            this.contractForm.setValue(res);
            this.onKeyDevice(res.mac_address);
            this.onKeyCustomer(res.customer_name);
            this.onKeyAgentPerson(res.agent_person_name);
          },
          error => this.errorMessage = error
        );
    }
    else{
      this.title = '(Create)';
    }
  }

  getContractPeriodsByContract(id) {
    this._contractService.getContractPeriodsByContract(id)
      .subscribe((data) => {
        this.contractSource.localdata = data;
        this.contractDataAdapter.dataBind();
      });
  }

  getMachinesByDeviceId(id) {
    this._machineService.getMachinesByDeviceId(id)
      .subscribe((data) => {
        this.machineSource.localdata = data;
        this.machineDataAdapter.dataBind();
        
      });
  }

  //getDeviceById(id) {
  //  this._masterService.getDeviceById(id)
  //    .subscribe((data) => {
  //      this.warrantyStr = (data.warranty == null)? null: (data.warranty.getMonth() + 1).toString() + "/" + data.warranty.getDate().toString() + "/" + data.warranty.getFullYear().toString();
  //    });
  //}

  getSupportsForContract(customerId, deviceId) {
    this._supportService.getSupportsForContract(customerId, deviceId)
      .subscribe((data) => {

        this.supportSource.localdata = data;
        this.supportDataAdapter.dataBind();
      });
  }

  getSymptoms(isNotALL: boolean) {
    this._masterService.getSymptoms(isNotALL)
      .subscribe((data) => {
        this.symptomsSource.localdata = data;
        this.symptomsDataAdapter.dataBind();
      });
  }

  getDropDownList() {
    //Plan
    this._masterService.getPlans(true)
      .subscribe(data => {
        this.planList = data;
      });
    //Payment
    this._masterService.getPayments(true)
      .subscribe(data => {
        this.paymentList = data;
      });
    //Device
    //this._masterService.getDevicesExcludeDisposed((this.title == "(Create)") ? 0 : this.data.device_id)
    this._masterService.getDevicesExcludeDisposed(this.data.device_id)
      .subscribe(data => {
        this.deviceList = data;
      });
    //Customer
    this._masterService.getCustomers(true)
      .subscribe(data => {
        this.customerList = data;
      });
    ////Agent
    //this._masterService.getAgents(true)
    //  .subscribe(data => {
    //    this.agentList = data;
    //  });
    //Agent Person
    //this._masterService.getAgentPersonsByAgentId(this.data.agent_id)
    this._masterService.getAgentPersons(true)
      .subscribe(data => {
        this.agentPersonList = data;
      });
    //Status
    this._masterService.getStatuss(true)
      .subscribe(data => {
        this.statusList = data;
      });
  }

  getWidth(): any {
    return '100%';
  }

  changeNewCustomer(new_customer_flg: boolean) {
    //document.getElementById("notNewCustomer").style.visibility = (new_customer_flg) ? "hidden" : "visible";
    //document.getElementById("NewCustomer").style.visibility = (new_customer_flg) ? "visible" : "hidden";
    this.holderEmail = ((new_customer_flg) ? "★ Please input " : "") + "Email";
    this.holderPhone = ((new_customer_flg) ? "★ Please input " : "") + "Phone";
    this.holderAddress = ((new_customer_flg) ? "★ Please input " : "") + "Address";
    if (new_customer_flg) {
      this.getSupportsForContract(0, 0);
    } else {
      this.getSupportsForContract(this.customer_id.value, this.device_id.value);
    }
  }

  //**************************************************************************************************************
  // PopUp Contract - Dropdown Contract Type [ contractGrid ]
  //**************************************************************************************************************
  contractTypes: any[] = [
    { contract_type_id: 1, contract_type: '新規' },
    { contract_type_id: 2, contract_type: '契約更新' },
    { contract_type_id: 3, contract_type: '無料モニター' },
    { contract_type_id: 4, contract_type: '例外(無料)' },
    //{ contract_type_id: 5, contract_type: '解約' },
  ];
  contractTypeSource: any =
    {
      datatype: 'array',
      datafields: [
        { name: 'contract_type_id', type: 'int' },
        { name: 'contract_type', type: 'string' }
      ],
      localdata: this.contractTypes
    };
  contractTypesDataAdapter: any = new jqx.dataAdapter(this.contractTypeSource, { autoBind: true });

  //grid source
  contractSource: any =
    {
      datatype: 'json',
      datafields: [
        { name: 'contract_period_id', type: 'int' },
        { name: 'contract_id', type: 'int' },
        { name: 'start_date', type: 'date' },
        { name: 'end_date', type: 'date' },
        { name: 'paid_flg', type: 'bool' },
        { name: 'free_flg', type: 'bool' },
        { name: 'formal_flg', type: 'bool' },
        { name: 'sent_email', type: 'date' },
        { name: 'email_type_id', type: 'int' },
        { name: 'email_type', type: 'string' },
        { name: 'contract_type_id', type: 'int' },
        { name: 'contract_type', type: 'string' },
        { name: 'contract', type: 'string' },
        { name: 'updated_by', type: 'string' },
        { name: 'updated_date', type: 'date' },
        { name: 'add_flg', type: 'bool' },
        { name: 'update_flg', type: 'bool' }
        //{ name: 'd_contract_type', value: 'contract_type_id', values: { source: this.contractTypesDataAdapter.records, value: 'contract_type_id', name: 'contract_type' } }
      ],
      id: 'contract_period_id',
      localdata: {},
      sortcolumn: 'end_date',
      sortdirection: 'desc',

      //addrow: (rowid, rowdata, position, commit): any => {
      //  // synchronize with the server - send insert command
      //  // call commit with parameter true if the synchronization with the server is successful 
      //  //and with parameter false if the synchronization failed.
      //  console.log(this.contractDataAdapter);

      //  commit(true);
      //},
    
      updaterow: (rowid, newdata, commit): any => {
        // synchronize with the server - send update command
        // call commit with parameter true if the synchronization with the server is successful 
        // and with parameter false if the synchronization failed.

        //this.updateList(rowid);

        //var today = new Date();
        //var todayStr = this._com.getDateTime(new Date());

        //newdata.updated_by = this.user;
        //newdata.updated_date = todayStr;

        if (newdata.add_flg != true) {
          newdata.update_flg = true
        }
        //console.log(this.contractDataAdapter);
        commit(true);
      }
    };
  contractDataAdapter: any = new jqx.dataAdapter(this.contractSource);

  //grid columns
  contractColumns: any[] =
    [
      { text: 'Id', datafield: 'contract_period_id', hidden: true },
      {
        text: '', datafield: 'contract_type_id', displayfield: 'contract_type', width: '25%', columntype: 'dropdownlist',
        createeditor: (row: number, column: any, editor: any): void => {
          editor.jqxDropDownList({ autoDropDownHeight: true, source: this.contractTypesDataAdapter, displayMember: 'contract_type', valueMember: 'contract_type_id' });
        },
      },
      { text: 'Start Date', datafield: 'start_date', width: '25%', columntype: 'datetimeinput', cellsformat: 'd' },
      { text: 'End Date', datafield: 'end_date', width: '25%', columntype: 'datetimeinput', cellsformat: 'd' },
      {
        text: 'Paid', datafield: 'paid_flg', width: '25%', columntype: 'checkbox', twostatecheckbox: true, align: 'center',
        cellvaluechanging: (row, datafield, columntype, oldvalue, newvalue): void => {
          if (this.contractGrid.getcellvalue(row, 'add_flg') != true) {
            this.contractDataAdapter.records[row].update_flg = true;
          }
        }
      }
    ];

  //add row
  contractGeneratedata(): any {
    var today = new Date();
    //var isPaid = "false";
    var todayStr = this._com.getDateTime(new Date());
    
    var lowStartDate = new Date("1/1/2010 12:00:00");
    var preType = "無料モニター";
    //var preTypeId = 3;
    //var OrgType = "";
    let crows = this.contractGrid.getrows();
    if (crows.length > 0) {
      crows.forEach(data => {
        //OrgType = data.contract_type;
        //if (this.status_code.value == "解約") {
        //  OrgType = "解約";
        //  preType = '解約';
        //  lowStartDate = today;
        //  isPaid = "true"
        //  preTypeId = 5;
        //}

        if (data.end_date > lowStartDate) {
          lowStartDate = data.end_date;
        }
        if (data.contract_type == "契約更新" || data.contract_type == '新規' || data.contract_type == '例外(無料)') {
          preType = "契約更新";
        } else if (preType != "契約更新" && data.contract_type == "無料モニター") {
          preType = '新規';
        }

        //if (OrgType == "契約更新" || OrgType == '新規' || OrgType == '例外(無料)') {
        //  preType = "契約更新";
        //  preTypeId = 2;
        //  data.contract_type_id = 1;
        //} else if (preType != "契約更新" && OrgType == "無料モニター") {
        //  preType = '新規';
        //  preTypeId = 1;
        //}
      })
    };



    var lowStartDateStr = (lowStartDate.getMonth() + 1).toString() + "/" + (lowStartDate.getDate()).toString() + "/" + lowStartDate.getFullYear().toString();
    if (lowStartDateStr == "1/2/2010") {
      lowStartDate = today;
      lowStartDateStr = (lowStartDate.getMonth() + 1).toString() + "/" + (lowStartDate.getDate()).toString() + "/" + lowStartDate.getFullYear().toString();
    }

    //if (OrgType != "解約") {
    //  lowStartDateStr = (lowStartDate.getMonth() + 1).toString() + "/" + (lowStartDate.getDate() + 1).toString() + "/" + lowStartDate.getFullYear().toString();
    //  if (lowStartDateStr == "1/2/2010") {
    //    lowStartDate = today;
    //    lowStartDateStr = (lowStartDate.getMonth() + 1).toString() + "/" + (lowStartDate.getDate()).toString() + "/" + lowStartDate.getFullYear().toString();
    //  }
    //}

    var todayStrh = (today.getMonth() + 1).toString() + "/" + (today.getDate()).toString() + "/" + today.getFullYear().toString();

    let row = {};
    row['contract_period_id'] = 0;
    row['start_date'] = lowStartDateStr;
    row['end_date'] = todayStrh;
    row['paid_flg'] = "false";
   //row['paid_flg'] = isPaid;
    //row['contract_type'] = (this.title == '(Create)')? "無料モニター" : "契約更新";
    row['contract_type'] = preType;
    //row['contract_type_id'] = preTypeId;
    row['add_flg'] = true;
    row['update_flg'] = false;

    return row;
  }

  //tool buttons
  contractCreateButtonsContainers(statusbar: any): void {
    let buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = 'overflow: hidden; position: relative; margin: 3px;';
    let AddButtonContainer = document.createElement('div');
    let DeleteButtonContainer = document.createElement('div');
    let ReloadButtonContainer = document.createElement('div');
    AddButtonContainer.id = 'contractAddButton';
    DeleteButtonContainer.id = 'contractDeleteButton';
    ReloadButtonContainer.id = 'contractReloadButton';
    AddButtonContainer.style.cssText = 'float: left; font-size: 9px;';
    DeleteButtonContainer.style.cssText = 'float: left; font-size: 9px;';
    ReloadButtonContainer.style.cssText = 'float: left; font-size: 9px;';
    AddButtonContainer.className = 'btn btn-default';
    DeleteButtonContainer.className = 'btn btn-default';
    ReloadButtonContainer.className = 'btn btn-default';
    buttonsContainer.appendChild(AddButtonContainer);
    buttonsContainer.appendChild(DeleteButtonContainer);
    buttonsContainer.appendChild(ReloadButtonContainer);
    statusbar[0].appendChild(buttonsContainer);
  }

  //create tool buttons
  contractCreateButtons(): void {
    let AddButtonOptions = {
      width: 5,
      //height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-plus' style='color:darkseagreen;'></span>"
    }
    let AddButton = jqwidgets.createInstance('#contractAddButton', 'jqxButton', AddButtonOptions);
    let DeleteButtonOptions = {
      width: 5,
      //height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-remove' style='color:indianred;'></span>"
    }
    let DeleteButton = jqwidgets.createInstance('#contractDeleteButton', 'jqxButton', DeleteButtonOptions);
    let ReloadButtonOptions = {
      width: 5,
      //height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-refresh' style='color:darkblue;' title='Find'></span>"
    }
    let ReloadButton = jqwidgets.createInstance('#contractReloadButton', 'jqxButton', ReloadButtonOptions);

    // add new row.
    AddButton.addEventHandler('click', (event: any): void => {
      //if(this.title == '(Create)'){
      //  this.errorMessage = "Please save this contract at first.";
      //  return;
      //}

      let selectedrowindex = this.contractGrid.getselectedrowindex();
      this.contractGrid.endcelledit(selectedrowindex, this.contractSelectedcell, false);

      let datarow = this.contractGeneratedata();
      this.contractGrid.addrow(null, datarow);
    });
    // delete selected row.
    DeleteButton.addEventHandler('click', (event: any): void => {
      //if(this.title == '(Create)'){
      //  this.errorMessage = "Please save this contract at first.";
      //  return;
      //}
      let selectedrowindex = this.contractGrid.getselectedrowindex();
      let rowscount = this.contractGrid.getdatainformation().rowscount;
      let id = this.contractGrid.getrowid(selectedrowindex);
      if (id != null) {
        this.contractGrid.deleterow(id);
        this.contractDelrows.push(id);
      }
    });
    // reload grid data.
    ReloadButton.addEventHandler('click', (event: any): void => {
      this.getContractPeriodsByContract(this.contract_id.value);
      this.contractDelrows = [];
      this.contractSelectedcell = null;
    });
  }

  contractGridOnCellBeginEdit(event: any): void {
    let args = event.args;
    this.contractSelectedcell = args.datafield;
  };

  //**************************************************************************************************************
  // PopUp Contract - Dropdown Symptom [ supportGrid ]
  //**************************************************************************************************************
  symptomsSource: any =
    {
      datatype: 'array',
      datafields: [
        { name: 'symptom_id', type: 'int' },
        { name: 'description', type: 'string' }
      ],
      localdata: {}
    };
  symptomsDataAdapter: any = new jqx.dataAdapter(this.symptomsSource, { autoBind: true });

  //grid source
  supportSource: any =
    {
      datatype: 'json',
      datafields: [
        { name: 'support_id', type: 'int' },
        { name: 'customer_id', type: 'int' },
        { name: 'customer_name', type: 'string' },
        { name: 'device_id', type: 'int' },
        { name: 'mac_address', type: 'string' },
        { name: 'supported', type: 'date' },
        { name: 'symptom_id', type: 'int' },
        { name: 'symptom_name', type: 'string' },
        { name: 'support_contents', type: 'string' },
        { name: 'updated_by', type: 'string' },
        { name: 'updated_date', type: 'date' },
        { name: 'add_flg', type: 'bool' },
        { name: 'update_flg', type: 'bool' }
      ],
      id: 'support_id',
      localdata: {},
      sortcolumn: 'support_id',
      sortdirection: 'desc',
    
      updaterow: (rowid, newdata, commit): any => {
        if (newdata.add_flg != true) {
          newdata.update_flg = true
        }
        commit(true);
      }
    };
  supportDataAdapter: any = new jqx.dataAdapter(this.supportSource);

  //grid columns
  supportColumns: any[] =
    [
      { text: 'Id', datafield: 'support_id', hidden: true },
      { text: 'Issue Date', datafield: 'supported', width: '25%', columntype: 'datetimeinput', cellsformat: 'd' },
      //{ text: 'Symptom', datafield: 'symptom_name', width: '25%', columntype: 'textbox' },
      {
        text: 'Symptom', datafield: 'symptom_id', displayfield: 'symptom_name', width: '25%', columntype: 'dropdownlist',
        createeditor: (row: number, column: any, editor: any): void => {
          editor.jqxDropDownList({ autoDropDownHeight: true, source: this.symptomsDataAdapter, displayMember: 'description', valueMember: 'symptom_id' });
        },
      },
      { text: 'Description', datafield: 'support_contents', width: '50%', columntype: 'textbox', editable: false }
    ];

  //add row
  supportGeneratedata(): any {
    var today = new Date();
    //var todayStr = this._com.getDateTime(new Date());
    let row = {};

    var todayStrh = (today.getMonth() + 1).toString() + "/" + (today.getDate()).toString() + "/" + today.getFullYear().toString();

    row['support_id'] = 0;
    row['supported'] = todayStrh;
    row['symptom_id'] = 0;
    row['symptom_name'] = "";
    row['support_contents'] = "";
    row['add_flg'] = true;
    row['update_flg'] = false;

    return row;
  }

  //tool buttons
  supportCreateButtonsContainers(statusbar: any): void {
    let buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = 'overflow: hidden; position: relative; margin: 3px;';
    let AddButtonContainer = document.createElement('div');
    let DeleteButtonContainer = document.createElement('div');
    let ReloadButtonContainer = document.createElement('div');
    AddButtonContainer.id = 'supportAddButton';
    DeleteButtonContainer.id = 'supportDeleteButton';
    ReloadButtonContainer.id = 'supportReloadButton';
    AddButtonContainer.style.cssText = 'float: left; font-size: 9px;';
    DeleteButtonContainer.style.cssText = 'float: left; font-size: 9px;';
    ReloadButtonContainer.style.cssText = 'float: left; font-size: 9px;';
    AddButtonContainer.className = 'btn btn-default';
    DeleteButtonContainer.className = 'btn btn-default';
    ReloadButtonContainer.className = 'btn btn-default';
    buttonsContainer.appendChild(AddButtonContainer);
    buttonsContainer.appendChild(DeleteButtonContainer);
    buttonsContainer.appendChild(ReloadButtonContainer);
    statusbar[0].appendChild(buttonsContainer);
  }

  //create tool buttons
  supportCreateButtons(): void {
    let AddButtonOptions = {
      width: 5,
      //height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-plus' style='color:darkseagreen;'></span>"
    }
    let AddButton = jqwidgets.createInstance('#supportAddButton', 'jqxButton', AddButtonOptions);
    let DeleteButtonOptions = {
      width: 5,
      //height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-remove' style='color:indianred;'></span>"
    }
    let DeleteButton = jqwidgets.createInstance('#supportDeleteButton', 'jqxButton', DeleteButtonOptions);
    let ReloadButtonOptions = {
      width: 5,
      //height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-refresh' style='color:darkblue;'></span>"
    }
    let ReloadButton = jqwidgets.createInstance('#supportReloadButton', 'jqxButton', ReloadButtonOptions);

    // add new row.
    AddButton.addEventHandler('click', (event: any): void => {
      if (this.contractForm.value.customer_id == 0 || this.new_customer_flg) {
        this.errorMessage = "Please save new customer at first."
        return;
      }
      let selectedrowindex = this.supportGrid.getselectedrowindex();
      this.supportGrid.endcelledit(selectedrowindex, this.supportSelectedcell, false);

      let datarow = this.supportGeneratedata();
      this.supportGrid.addrow(null, datarow);
      //this.myEditor.val('');
      this.isOpenSupport = false;
    });
    // delete selected row.
    DeleteButton.addEventHandler('click', (event: any): void => {
      if (this.contractForm.value.customer_id == 0 || this.new_customer_flg) {
        this.errorMessage = "Please save new customer at first."
        return;
      }
      let selectedrowindex = this.supportGrid.getselectedrowindex();
      let rowscount = this.supportGrid.getdatainformation().rowscount;
      let id = this.supportGrid.getrowid(selectedrowindex);
      if (id != null) {
        this.supportGrid.deleterow(id);
        this.supportDelrows.push(id);
      }
    });
    // reload grid data.
    ReloadButton.addEventHandler('click', (event: any): void => {
      this.getSupportsForContract(this.customer_id.value, this.device_id.value);
      this.supportDelrows = [];
      this.supportSelectedcell = null;
      this.isOpenSupport = false;
    });
  }

  supportGridOnCellBeginEdit(event: any): void {
    let args = event.args;
    this.supportSelectedcell = args.datafield;
  };

  Rowdoubleclick(event: any): void {
    this.isOpenSupport = true;
    let selectedrowindex = this.supportGrid.getselectedrowindex();
    let id = this.supportGrid.getrowdata(selectedrowindex).support_id;
    this.getSupportById(id);
  }

  getSupportById(id) {
    if (id > 0) {
      this._supportService.getSupportById(id)
        .subscribe(
          res => {
            //this.supportForm.setValue(res);
            this.myEditor.val(res.support_contents);
          },
          error => this.errorMessage = error
        );
    }
    //else {
    //  this.myEditor.val('');
    //}
  }

  //**************************************************************************************************************
  // PopUp Contract - Support Contents [ Support Edier  ]
  //**************************************************************************************************************
  supportTools: string = 'apply | clear | size | color | bold  italic underline | close';
  createCommandSupportContents = (name: string): any => {
    switch (name) {
      case 'datetime':
        return {
          type: 'list',
          tooltip: 'Insert Date/Time',
          init: (widget: any): void => {
            widget.jqxDropDownList({ placeHolder: 'Insert Custom HTML', width: 170, source: ['Insert Time', 'Insert Date'], autoDropDownHeight: true });
          },
          refresh: (widget: any, style: any): void => {
            // do something here when the selection is changed.
            widget.jqxDropDownList('clearSelection');
          },
          action: (widget: any, editor: any): any => {
            let widgetValue = widget.val();
            let date = new Date();
            // return object with command and value members.
            return { command: 'inserthtml', value: widgetValue == 'Insert Time' ? date.getHours() + ':' + date.getMinutes() : date.getDate() + '-' + (date.getMonth() + 1).toString() + '-' + date.getFullYear() };
          }
        }
      case 'print':
        return {
          type: 'button',
          tooltip: 'Print',
          init: (widget: any): void => {
            widget.jqxButton({ height: 25, width: 40 });
            widget.html('<span style="line-height: 24px;">Print</span>');
          },
          refresh: (widget: any, style: any): void => {
            // do something here when the selection is changed.
          },
          action: (widget: any, editor: any): void => {
            // return nothing and perform a custom action.
            this.myEditor.print();
          }
        }
      case 'clear':
        return {
          type: 'button',
          tooltip: 'Clear',
          init: (widget: any): void => {
            widget.jqxButton({ height: 25, width: 40 });
            widget.html('<span style="line-height: 24px;">Clear</span>');
          },
          refresh: (widget: any, style: any): void => {
            // do something here when the selection is changed.
          },
          action: (widget: any, editor: any): void => {
            // return nothing and perform a custom action.
            this.myEditor.val('')
          }
        }
      case 'backcolor':
        return {
          type: 'colorPicker',
          tooltip: 'Background',
          init: (widget: any): void => {
            widget.jqxDropDownButton({ width: 170 });
            widget.jqxDropDownButton('setContent', '<span style="line-height: 24px;">Choose Background</span>');
          },
          refresh: (widget: any, style: any): void => {
            // do something here when the selection is changed.
          },
          action: (widget: any, editor: any): void => {
            // return nothing and perform a custom action.
            let color = widget.val();
            editor.css('background', color);
          }
        }
      case 'apply':
        return {
          type: 'button',
          tooltip: 'Apply',
          init: (widget: any): void => {
            widget.jqxButton({ height: 25, width: 40 });
            widget.html('<span style="line-height: 24px;">Apply</span>');
          },
          refresh: (widget: any, style: any): void => {
            // do something here when the selection is changed.
          },
          action: (widget: any, editor: any): void => {
            // return nothing and perform a custom action.
            let id = this.supportGrid.getselectedrowindex();
            this.supportGrid.setcellvalue(id, 'support_contents', this.myEditor.val());
            this.isOpenSupport = false;
          }
        }
      case 'close':
        return {
          type: 'button',
          tooltip: 'Close',
          init: (widget: any): void => {
            widget.jqxButton({ height: 25, width: 40 });
            widget.html('<span style="line-height: 24px;">Close</span>');
          },
          refresh: (widget: any, style: any): void => {
            // do something here when the selection is changed.
          },
          action: (widget: any, editor: any): void => {
            // return nothing and perform a custom action.
            this.isOpenSupport = false;
          }
        }
    }
  };

  getWidthSupportContents(): any {
    return '100%';
  }

  getHeightSupportContents(): any {
    return '30%';
  }

  //**************************************************************************************************************
  // PopUp Contract - Machine Information [ machineGrid  ]
  //**************************************************************************************************************
  machineSource: any =
    {
      datatype: 'json',
      datafields: [
        { name: 'machine_id', type: 'int' },
        { name: 'contract_id', type: 'int' },
        { name: 'device_id', type: 'int' },
        { name: 'mac_address', type: 'string' },
        { name: 'order_no', type: 'string' },
        //{ name: 'warranty', type: 'date' },//08/16/2019 Warranty 不要
        { name: 'lent', type: 'date' },
        { name: 'returned', type: 'date' },
        { name: 'remarks', type: 'string' },
        { name: 'dispose_flg', type: 'bool' },
        { name: 'updated_by', type: 'string' },
        { name: 'updated_date', type: 'date' },
        { name: 'add_flg', type: 'bool' },
        { name: 'update_flg', type: 'bool' }
      ],
      id: 'machine_id',
      localdata: {},
      sortcolumn: 'machine_id',
      sortdirection: 'desc',
    
      updaterow: (rowid, newdata, commit): any => {
        if (newdata.add_flg != true) {
          newdata.update_flg = true
        }
        //console.log(this.contractDataAdapter);
        commit(true);
      }
    };
  machineDataAdapter: any = new jqx.dataAdapter(this.machineSource);

  //grid columns
  machineColumns: any[] =
    [
      { text: 'Id', datafield: 'machine_id', hidden: true },
      { text: 'Contract#', datafield: 'contract_id', width: '20%', align: 'right', cellsalign: 'right', columntype: 'textbox', editable: false},
      { text: 'Issue Date', datafield: 'lent', width: '30%', columntype: 'datetimeinput', cellsformat: 'd' },
      { text: 'Return Date', datafield: 'returned', width: '30%', columntype: 'datetimeinput', cellsformat: 'd' },
      { text: 'Disposed', datafield: 'dispose_flg', width: '20%', columntype: 'checkbox', twostatecheckbox: true, align: 'center',
        cellvaluechanging: (row, datafield, columntype, oldvalue, newvalue): void => {
          if (this.machineGrid.getcellvalue(row, 'add_flg') != true) {
            this.machineDataAdapter.records[row].update_flg = true;
          }
        }
      }
      //{ text: 'Warranty', datafield: 'warranty', width: '20%', columntype: 'datetimeinput', cellsformat: 'MM/dd/yyyy', editable: false } //08/16/2019 Warranty 不要
    ];

  //add row
  machineGeneratedata(): any {
    var lowStartDate = new Date("1/1/2010 12:00:00");
    let crows = this.contractGrid.getrows();
    if (crows.length > 0) {
      crows.forEach(data => {
        var test = (lowStartDate.getMonth() + 1).toString() + "/" + (lowStartDate.getDate()).toString() + "/" + lowStartDate.getFullYear().toString();
        if (test ==  "1/1/2010") {
          lowStartDate = data.start_date;
        }else if (data.start_date < lowStartDate) {
          lowStartDate = data.start_date;
        }
      })
    };

    var lowStartDateStr = (lowStartDate.getMonth() + 1).toString() + "/" + (lowStartDate.getDate()).toString() + "/" + lowStartDate.getFullYear().toString();
    if (lowStartDateStr == "1/1/2010") {
      lowStartDate = new Date();
      lowStartDateStr = (lowStartDate.getMonth() + 1).toString() + "/" + (lowStartDate.getDate()).toString() + "/" + lowStartDate.getFullYear().toString();
    }

    let row = {};
    row['machine_id'] = 0;
    row['contract_id'] = this.contract_id.value;
    row['lent'] = lowStartDateStr;
    row['returned'] = "";
    //row['warranty'] = this.warrantyStr;
    row['dispose_flg'] = "false";
    row['add_flg'] = true;
    row['update_flg'] = false;

    return row;
  }

  //tool buttons
  machineCreateButtonsContainers(statusbar: any): void {
    let buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = 'overflow: hidden; position: relative; margin: 3px;';
    let AddButtonContainer = document.createElement('div');
    let DeleteButtonContainer = document.createElement('div');
    let ReloadButtonContainer = document.createElement('div');
    AddButtonContainer.id = 'machineAddButton';
    DeleteButtonContainer.id = 'machineDeleteButton';
    ReloadButtonContainer.id = 'machineReloadButton';
    AddButtonContainer.style.cssText = 'float: left; font-size: 9px;';
    DeleteButtonContainer.style.cssText = 'float: left; font-size: 9px;';
    ReloadButtonContainer.style.cssText = 'float: left; font-size: 9px;';
    AddButtonContainer.className = 'btn btn-default';
    DeleteButtonContainer.className = 'btn btn-default';
    ReloadButtonContainer.className = 'btn btn-default';
    buttonsContainer.appendChild(AddButtonContainer);
    buttonsContainer.appendChild(DeleteButtonContainer);
    buttonsContainer.appendChild(ReloadButtonContainer);
    statusbar[0].appendChild(buttonsContainer);
  }

  //create tool buttons
  machineCreateButtons(): void {
    let AddButtonOptions = {
      width: 5,
      //height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-plus' style='color:darkseagreen;'></span>"
    }
    let AddButton = jqwidgets.createInstance('#machineAddButton', 'jqxButton', AddButtonOptions);
    let DeleteButtonOptions = {
      width: 5,
      //height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-remove' style='color:indianred;'></span>"
    }
    let DeleteButton = jqwidgets.createInstance('#machineDeleteButton', 'jqxButton', DeleteButtonOptions);
    let ReloadButtonOptions = {
      width: 5,
      //height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-refresh' style='color:darkblue;'></span>"
    }
    let ReloadButton = jqwidgets.createInstance('#machineReloadButton', 'jqxButton', ReloadButtonOptions);

    // add new row.
    AddButton.addEventHandler('click', (event: any): void => {
      if(this.title == '(Create)'){
        this.errorMessage = "Please save this contract at first.";
        return;
      }

      let selectedrowindex = this.machineGrid.getselectedrowindex();
      this.machineGrid.endcelledit(selectedrowindex, this.machineSelectedcell, false);

      let datarow = this.machineGeneratedata();
      this.machineGrid.addrow(null, datarow);
    });
    // delete selected row.
    DeleteButton.addEventHandler('click', (event: any): void => {
      if(this.title == '(Create)'){
        this.errorMessage = "Please save this contract at first.";
        return;
      }
      let selectedrowindex = this.machineGrid.getselectedrowindex();
      let rowscount = this.machineGrid.getdatainformation().rowscount;
      let id = this.machineGrid.getrowid(selectedrowindex);
      if (id != null) {
        this.machineGrid.deleterow(id);
        this.machineDelrows.push(id);
      }
    });
    // reload grid data.
    ReloadButton.addEventHandler('click', (event: any): void => {
      this.getMachinesByDeviceId(this.device_id.value);
      this.machineDelrows = [];
      this.machineSelectedcell = null;
    });
  }

  machineGridOnCellBeginEdit(event: any): void {
    let args = event.args;
    this.machineSelectedcell = args.datafield;
  };


  //**************************************************************************************************************

  //Dropdown events
  planOnSelect(event: any): void {
    let value = event.value;
    if (value > 0) {
      this._masterService.getPlanById(value)
        .subscribe(
          data => {
            this.plan_type.setValue(data.term_name);
            //this.item_id.setValue(data.item_id);
          });
    }
    else {
      this.plan_type.setValue(null);
      //this.item_id.setValue(null);
    }
  }
  customerOnSelect(event: any): void {
    let value = event.value;
    if (value > 0) {
      this._masterService.getCustomerById(value)
        .subscribe(
          data => {
            this.customer_id.setValue(data.customer_id);
            this.customer_name.setValue(data.name);
            //this.customer_state.setValue(data.state);
            //this.customer_city.setValue(data.city);
            this.customer_address.setValue(data.address);
            this.customer_email.setValue(data.email);
            this.customer_phone.setValue(data.phone);
          });
    }
    else {
      this.customer_id.setValue(0);
      this.customer_name.setValue(null);
      //this.customer_state.setValue(null);
      //this.customer_city.setValue(null);
      this.customer_address.setValue(null);
      this.customer_email.setValue(null);
      this.customer_phone.setValue(null);
    }
    this.getSupportsForContract(this.customer_id.value, this.device_id.value);
  }
  paymentOnSelect(event: any): void {
    let value = event.value;
    if (value > 0) {
      this._masterService.getPaymentById(value)
        .subscribe(
          data => {
            this.payment_name.setValue(data.description);
          });
    }
    else {
      this.payment_name.setValue(null);
    }
  }
  macOnSelect(event: any): void {
    let value = event.value;
    if (value > 0) {
      this._masterService.getDeviceById(value)
        .subscribe(
          data => {
            this.device_id.setValue(data.device_id);
            this.mac_address.setValue(data.mac_address);
            this.order_no.setValue(data.order_no);
            //this.warrantyStr = (data.warranty == null)? null: (data.warranty.getMonth() + 1).toString() + "/" + data.warranty.getDate().toString() + "/" + data.warranty.getFullYear().toString();
          });
    }
    else {
      this.device_id.setValue(0);
      this.mac_address.setValue(null);
      this.order_no.setValue(null);
      //this.warrantyStr = null;
    }
    //change grid data
    this.getMachinesByDeviceId(this.device_id.value);
    this.getSupportsForContract(this.customer_id.value, this.device_id.value);
  }
  //agentOnSelect(event: any): void {
  //  let value = event.value;
  //  if (value > 0) {
  //    this._masterService.getAgentById(value)
  //      .subscribe(
  //        data => {
  //          this.agent_id.setValue(data.agent_id);
  //          this.agent_name.setValue(data.name);
  //        });
  //    this._masterService.getAgentPersonsByAgentId(value)
  //      .subscribe(
  //        data => {
  //          this.agentPersonList = data;

  //          this.agent_person_id.setValue(this.agentPersonList[0].agent_person_id);
  //          this.agent_person_name.setValue(this.agentPersonList[0].agent_person_name);
  //          this.commission.setValue(this.agentPersonList[0].basic_rate);
  //        });
  //  }
  //  else {
  //    this.agent_id.setValue(0);
  //    this.agent_name.setValue(null);
  //    this.agent_person_id.setValue(0);
  //    this.agent_person_name.setValue(null);
  //    this.commission.setValue(0);
  //  }

  //}
  agentPersonOnSelect(event: any): void {
    let value = event.value;
    if (value > 0) {
      this._masterService.getAgentPersonById(value)
        .subscribe(
          data => {
            this.agent_person_name.setValue(data.name);
            this.commission.setValue(data.basic_rate);
          });
    }
    else {
      this.agent_person_name.setValue(null);
      this.commission.setValue(0);
    }
  }

  statusOnSelect(event: any): void {
    let value = event.value;
    if (value > 0) {
      this._masterService.getStatusById(value)
        .subscribe(
          data => {
            this.status_code.setValue(data.description);
          });
    }
    else {
      this.status_code.setValue(null);
    }
  }

  //Save Data
  saveData() {
    this.errorMessage = null;
    this.successMessage = null;
    //check form
    if (this.contractForm.invalid) {
      console.log(this.contractForm);
      this.errorMessage = 'Please enter all required fields.';
      return;
    }

    //check grid
    let selectedrowindex = this.contractGrid.getselectedrowindex();
    this.contractGrid.endcelledit(selectedrowindex, this.contractSelectedcell, false);
    if (this.contractGrid.getrows().length == 0) {
      this.errorMessage = 'Please enter contract type.';
      return;
    }

    if (this.new_customer_flg) {
      this._masterService.checkCustomer(this.contractForm.value.customer_name)
        .subscribe(
          data => {
            if (data.customer_id > 0) {
              if (!confirm("This customer has already existed. Are you sure you want to save this contract?")) {
                return;
              }

              this.contractForm.value.customer_id = data.customer_id;
              //this.customer_id.value.setValue(data.customer_id);
              this.saveContract();
            } else {
              // Add New Customer
              if (!confirm("Are you sure you want to save this data?")) {
                return;
              }

              this.saveCustomer(data);
            }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to save the data. ";
            }
          });
    }
    else {
      if (!confirm("Are you sure you want to save this data?")) {
        return;
      }
      this.saveContract();
    }
  }

  // Save Customer
  saveCustomer(contractId): void {
    this._masterService.addCustomer(this.customerData())
      .subscribe(
        res => {
          if (res != 0) {
            this.new_customer_flg = false;
            this.changeNewCustomer(this.new_customer_flg);
            this.successMessage = "You have successfully added the data.";
            this.errorMessage = null;
            this.customer_id.setValue(res);
            this.contractForm.value.customer_id = res;
            this.saveContract();
          }
        },
        error => {
          this.successMessage = null;
          if (error != null) {
            this.errorMessage = error._body;
          }
          else {
            this.errorMessage = "Failed to save the data. ";
          }
        });
  }

  customerData(): any {
    var todayStr = this._com.getDateTime(new Date());
    let row = {};
    row['customer_id'] = 0;
    row['name'] = this.customer_name.value;
    row['email'] = this.customer_email.value;
    row['phone'] = this.customer_phone.value;
    row['address'] = this.customer_address.value;
    row['inactive'] = false;
    row['updated_by'] = this.user;
    row['updated_date'] = todayStr;
    return row;
  }

  // Save Contract
  saveContract() {
    this.errorMessage = null;
    this.successMessage = null;

    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());

    if (this.contract_id.value == 0) {
      this.contractForm.value.customer_id = (this.customer_name.value == "" || this.customer_name.value == null) ? 0 : this.customer_id.value;
      this.contractForm.value.agent_person_id = (this.agent_person_name.value == "" || this.agent_person_name.value == null) ? 0 : this.agent_person_id.value;
      this.contractForm.value.device_id = (this.mac_address.value == "" || this.mac_address.value == null) ? 0 : this.device_id.value;
      this._contractService.addContract(this.contractForm.value)
        .subscribe(
          data => {
            if (data > 0) {
              this.title = "(Edit)";
              this.savePeriods(data);
              this.saveSupports();
              this.saveMachines(data);
              this.getContractById(data);
              //this.getContractPeriodsByContract(data);
              //this.getSupportsForContract(this.customer_id.value, this.device_id.value);
              //this.getMachinesByDeviceId(this.device_id.value);
              //}
              this.successMessage = "You have successfully added the data.";
            } else {
              this.errorMessage = "Failed to save the data. ";
              this.title = "(Create)";
            }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to save the data. ";
              this.title = "(Create)";
            }
          });
    }
    else {
      this.updated_by.setValue(this.user);
      this.updated_date.setValue(todayStr);
      this._contractService.updateContract(this.contractForm.value)
        .subscribe(
          data => {
            if (data > 0) {
              this.savePeriods(data);
              this.saveSupports();
              this.saveMachines(data);
              this.getContractById(data);

              this.getSupportsForContract(this.customer_id.value, this.device_id.value);
              this.getMachinesByDeviceId(this.device_id.value);

              this.successMessage = "You have successfully update the data.";
            } else {
              this.successMessage = null;
              this.errorMessage = "Failed to update the data. ";
            }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to update the data. ";
            }
          });
    }
  }

  // Save Contract Period
  savePeriods(contractId): void {
    let rows = this.contractGrid.getrows();
    let isNotTwoFreeMoniter = true;

    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());

    rows.forEach(data => {
      let org_contract_period_id = data.contract_period_id;
      let org_contract_period_type = data.contract_type;

      isNotTwoFreeMoniter = true;
      data.contract_id = contractId;
      if(org_contract_period_type == "無料モニター" || org_contract_period_type == "例外(無料)"){
        data.paid_flg = true;
      }

      if (data.add_flg == true) {
        //12162019 無料モニターのみ二つ以上は追加できない様に指定
        if(org_contract_period_type == "無料モニター" || org_contract_period_type == "新規"){
          this.contractSource.localdata.forEach(data => {
            if(data.contract_type == org_contract_period_type && data.contract_period_id != org_contract_period_id){
              isNotTwoFreeMoniter = false;
            }
          });
        }

        if(isNotTwoFreeMoniter){
          data.updated_by = this.user;
          data.updated_date = todayStr;
          this._contractService.addContractPeriod(data)
            .subscribe(
              res => {
                if (res == 0) {
                  this.successMessage = null;
                  this.errorMessage = "Failed to save the data. ";
                  this.title = "(Create)";
                } else {
                  this.getContractPeriodsByContract(this.contract_id.value);
                }
            },
            error => {
              this.successMessage = null;
              if (error != null) {
                this.errorMessage = error._body;
              }
              else {
                this.errorMessage = "Failed to save the data. ";
                this.title = "(Create)";
              }
            });
        }else{
          this.getContractPeriodsByContract(this.contract_id.value);
        }
      }
      else if (data.update_flg == true) {
        data.updated_by = this.user;
        data.updated_date = todayStr;

        //12162019 無料モニターのみ二つ以上は追加できない様に指定
        if(org_contract_period_type == "無料モニター" || org_contract_period_type == "新規"){
          this.contractSource.localdata.forEach(data => {
            if(data.contract_type == org_contract_period_type && data.contract_period_id != org_contract_period_id){
              isNotTwoFreeMoniter = false;
            }
          });
        }

        if(isNotTwoFreeMoniter){
          this._contractService.updateContractPeriod(data)
            .subscribe(
              res => {
                if (res == 0) {
                  this.successMessage = null;
                  this.errorMessage = "Failed to save the data. ";
                }else{
                  this.getContractPeriodsByContract(this.contract_id.value);
                }
            },
            error => {
              this.successMessage = null;
              if (error != null) {
                this.errorMessage = error._body;
              }
              else {
                this.errorMessage = "Failed to save the data. ";
              }
            });
        }else{
          this.getContractPeriodsByContract(this.contract_id.value);
        }
      }
    });

    this.contractDelrows.forEach(id => {
      if (id != 0) {
        this._contractService.deleteContractPeriod(id)
          .subscribe(
            res => {
              if (res != 1) {
                this.successMessage = null;
                this.errorMessage = "Failed to save the data. ";
              }else{
                this.getContractPeriodsByContract(this.contract_id.value);
              }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to save the data. ";
            }
          });
      }
    });
    this.contractDelrows = [];
    this.contractSelectedcell = null;
  }

  // Save Support
  saveSupports(): void {
    let rows = this.supportGrid.getrows();

    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());

    rows.forEach(data => {
      data.customer_id = this.customer_id.value;
      data.customer_name = this.customer_name.value;
      data.device_id = this.device_id.value;
      data.mac_address = this.mac_address.value;

      if (data.add_flg == true) {
        data.updated_by = this.user;
        data.updated_date = todayStr;
        this._supportService.addSupport(data)
          .subscribe(
            res => {
              if (res == 0) {
                this.successMessage = null;
                this.errorMessage = "Failed to save the data. ";
                this.title = "(Create)";
              }else{
                this.getSupportsForContract(this.customer_id.value, this.device_id.value);
              }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to save the data. ";
              this.title = "(Create)";
            }
          });
      }
      else if (data.update_flg == true) {
        data.updated_by = this.user;
        data.updated_date = todayStr;
        this._supportService.updateSupport(data)
          .subscribe(
            res => {
              if (res == 0) {
                this.successMessage = null;
                this.errorMessage = "Failed to save the data. ";
              }else{
                this.getSupportsForContract(this.customer_id.value, this.device_id.value);
              }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage += "Failed to save the data. ";
            }
          });
      }
    });
    this.supportDelrows.forEach(id => {
      if (id != 0) {
        this._supportService.deleteSupport(id)
          .subscribe(
            res => {
              if (res != 1) {
                this.successMessage = null;
                this.errorMessage = "Failed to save the data. ";
              }else{
                this.getSupportsForContract(this.customer_id.value, this.device_id.value);
              }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to save the data. ";
            }
          });
      }
    });
    this.supportDelrows = [];
    this.supportSelectedcell = null;
  }

  // Save Machine
  saveMachines(contractId): void {
    let rows = this.machineGrid.getrows();

    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());

    if (rows.length > 0) {

      rows.forEach(data => {

        data.contract_id = contractId;
        data.contract_no = contractId;
        data.device_id = this.device_id.value;
        data.mac_address = this.mac_address.value;
        data.order_no = this.order_no.value;

        if (data.add_flg == true) {
          data.updated_by = this.user;
          data.updated_date = todayStr;
          this._machineService.addMachine(data)
            .subscribe(
              res => {
                if (res == 0) {
                  this.successMessage = null;
                  this.errorMessage = "Failed to save the data. ";
                  this.title = "(Create)";
                } else {
                  this.getMachinesByDeviceId(this.device_id.value);
                }

              },
              error => {
                this.successMessage = null;
                if (error != null) {
                  this.errorMessage = error._body;
                }
                else {
                  this.errorMessage = "Failed to save the data. ";
                  this.title = "(Create)";
                }
              });
        }
        else if (data.update_flg == true) {
          data.updated_by = this.user;
          data.updated_date = todayStr;
          this._machineService.updateMachine(data)
            .subscribe(
              res => {
                if (res == 0) {
                  this.successMessage = null;
                  this.errorMessage = "Failed to save the data. ";
                } else {
                  this.getMachinesByDeviceId(this.device_id.value);
                }
              },
              error => {
                this.successMessage = null;
                if (error != null) {
                  this.errorMessage = error._body;
                }
                else {
                  this.errorMessage = "Failed to save the data. ";
                }
              });
        }
      });
      this.machineDelrows.forEach(id => {
        if (id != 0) {
          this._machineService.deleteMachine(id)
            .subscribe(
              res => {
                if (res != 1) {
                  this.successMessage = null;
                  this.errorMessage = "Failed to save the data. ";
                } else {
                  this.getMachinesByDeviceId(this.device_id.value);
                }
              },
              error => {
                this.successMessage = null;
                if (error != null) {
                  this.errorMessage = error._body;
                }
                else {
                  this.errorMessage = "Failed to save the data. ";
                }
              });
        }
      });
      this.machineDelrows = [];
      this.machineSelectedcell = null;
    }

    //else if (rows.length = 0) {
    //  let crows = this.contractGrid.getrows();
    //  var lowStartDate = new Date();
    //  if (crows.length > 0) {

    //    crows.forEach(data => {
    //      if (lowStartDate == null) {
    //        lowStartDate = data.start_date;
    //      }
    //      else if (data.start_date < lowStartDate) {
    //        lowStartDate = data.start_date;
    //      }
    //    });
    //  }

    //  var lowStartDateStr = (lowStartDate.getMonth() + 1).toString() + "/" + lowStartDate.getDate().toString() + "/" + lowStartDate.getFullYear().toString();
      
    //  var rowData = this.machineData();
    //  rowData.contract_id = contractId;
    //  rowData.contract_no = contractId;
    //  rowData.device_id = this.device_id.value;
    //  rowData.mac_address = this.mac_address.value;
    //  rowData.order_no = this.order_no.value;
    //  rowData.contract_id = contractId;
    //  rowData.lent = lowStartDateStr;
    //  rowData.returned = "";
    //  rowData.updated_by = this.user;
    //  rowData.updated_date = todayStr;

    //  this._machineService.addMachine(rowData)
    //    .subscribe(
    //      res => {
    //        if (res == 0) {
    //          this.successMessage = null;
    //          this.errorMessage = "Failed to save the data. ";
    //        } else {
    //          this.getMachinesByDeviceId(this.device_id.value);
    //        }
    //      },
    //      error => {
    //        this.successMessage = null;
    //        if (error != null) {
    //          this.errorMessage = error._body;
    //        }
    //        else {
    //          this.errorMessage = "Failed to save the data. ";
    //        }
    //      });
    //}
  }

  //Delete Data
  deleteContract() {
    if (!confirm("Are you sure you want to delete this data?")) {
      //console.log('no');
      return;
    }

    if (this.contract_id != null && this.contract_id.value != 0) {
      //delete machine
      let machines = this.machineGrid.getrows();
      for (var i = 0; i < machines.length; i++) {
        if (machines[i].contract_id == this.contract_id.value) {
          this._machineService.deleteMachine(machines[i].machine_id)
            .subscribe(
              res => {
                if (res != 1) {
                  this.successMessage = null;
                  this.errorMessage = "Failed to save the data. ";
                } else {
                  this.getMachinesByDeviceId(this.device_id.value);
                  this.successMessage = "You have successfully deleted the data.";
                }
              },
              error => {
                this.successMessage = null;
                if (error != null) {
                  this.errorMessage = error._body;
                }
                else {
                  this.errorMessage = "Failed to save the data. ";
                }
              });
        }
      }

      //contract and contract_period
      this._contractService.deleteContract(this.contract_id.value)
        .subscribe(
          data => {
            if (data == 1) {
              this.dialogRef.close();
            }
            else {
              this.errorMessage = ' Failed to delete data.';
            }
          },
          error => {
            if (error != null) {
              this.errorMessage = error._body;
            }
          }
        )
    };
  }

  //Copy Data
  copyContract() {
    if (!confirm("Are you sure you want to replace new contract?")) {
      return;
    }

    //this._masterService.getDevicesExcludeDisposed(0)
    //  .subscribe(data => {
    //    this.deviceList = data;
    //  });

    //var isValid = false;
    //for (let i = 0; i < this.deviceList.length; i++) {
    //  let option = this.deviceList[i];
    //  if (option.mac_address.toLowerCase().indexOf(this.contractForm.value.mac_address.toLowerCase()) >= 0) {
    //    isValid = true;
    //  }
    //}

    //this.contractForm.patchValue({
    //  contract_id: 0,
    //  mac_address: ((isValid) ? this.contractForm.value.mac_address : '' )
    //});

    this.title = '(Create)';

    this._masterService.getListDevicesForDropDownSearchList(0, this.contractForm.value.mac_address)
      .subscribe(data => {
        this.deviceList = data;

        var isValid = false;
        for (let i = 0; i < this.deviceList.length; i++) {
          let option = this.deviceList[i];
          if (option.mac_address.toLowerCase().indexOf(this.contractForm.value.mac_address.toLowerCase()) >= 0) {
            isValid = true;
          }
        }

        this.contractForm.patchValue({
          contract_id: 0,
          device_id: ((isValid) ? this.contractForm.value.device_id : 0),
          mac_address: ((isValid) ? this.contractForm.value.mac_address : '')
        });

        this.getMachinesByDeviceId(this.contractForm.value.device_id);
      });

    let datarow = this.contractGeneratedataForCopy();
    //this.getContractPeriodsByContract(0);
    this.contractSource.localdata = datarow;
    this.contractDataAdapter.dataBind();
    //this.contractGrid.addrow(null, datarow);
    //this.ngForm.contract_id == 0;
    //this.contractForm.setValue(res)
  }

  //add row
  contractGeneratedataForCopy(): any {
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.pre_end_date = this.getLatestEndDate();
    var endDateStr = (this.pre_end_date == null)?  todayStr : (this.pre_end_date.getMonth() + 1).toString() + "/" + this.pre_end_date.getDate().toString() + "/" + this.pre_end_date.getFullYear().toString();
    let row = {};
    row['contract_period_id'] = 0;
    row['start_date'] = todayStr;
    row['end_date'] = endDateStr;
    row['paid_flg'] = "true";
    row['contract_type'] = "例外(無料)";
    row['add_flg'] = true;
    row['update_flg'] = false;

    return row;
  }

  getLatestEndDate(): any {
    let rows = this.contractGrid.getrows();
    var pre_date = new Date();
    var res = null;
    rows.forEach(data => {
      if(pre_date <= data.end_date){
        res = (pre_date <= data.end_date)? data.end_date : pre_date;
      }
      pre_date = data.end_date;
    });
    return res;
  }

  // Device
  onKeyDevice(value) {
    this.deviceSearchedList = [];
    if (typeof value != "undefined" && value != null && value != "") {
      this._masterService.getListDevicesForDropDownSearchList(this.contract_id.value, value)
        .subscribe(
          res => {
            this.deviceSearchedList = res;
            //this.searchedList.push(res); //error
          },
          error => this.errorMessage = error
        );
    } else {
      this.device_id.setValue(0);
      this.mac_address.setValue("");
    }
  }

  // Customer
  onKeyCustomer(value) {
    this.customerSearchedList = [];
    this._masterService.getListCustomersForDropDownSearchList(value)
      .subscribe(
        res => {
          this.customerSearchedList = res;
          //this.searchedList.push(res); //error
        },
        error => this.errorMessage = error
      );
  }

  // Agent Person
  onKeyAgentPerson(value) {
    this.agentPersonSearchedList = [];
    if (typeof value != "undefined" && value != null && value != "") {
      //this._masterService.getListAgentsPersonForDropDownSearchList(value)
      //  .subscribe(
      //    res => {
      //      this.agentSearchedList = res;
      //      //this.searchedList.push(res); //error
      //    },
      //    error => this.errorMessage = error
      //  );
      //this._masterService.getAgentPersonsByAgentNameForDropDownSearchList(value)
      this._masterService.getAgentPersonsByNameForDropDownSearchList(value)
        .subscribe(
          res => {
            this.agentPersonSearchedList = res;
          },
          error => this.errorMessage = error
        );
    } 
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }

  get contract_id() { return this.contractForm.get('contract_id'); }
  //get item_id() { return this.contractForm.get('item_id'); }
  get device_id() { return this.contractForm.get('device_id'); }
  get mac_address() { return this.contractForm.get('mac_address'); }
  get plan_id() { return this.contractForm.get('plan_id'); }
  get plan_type() { return this.contractForm.get('plan_type'); }
  get payment_id() { return this.contractForm.get('payment_id'); }
  get payment_name() { return this.contractForm.get('payment_name'); }
  get order_no() { return this.contractForm.get('order_no'); }
  get customer_id() { return this.contractForm.get('customer_id'); }
  get customer_name() { return this.contractForm.get('customer_name'); }
  //get customer_state() { return this.contractForm.get('customer_state'); }
  //get customer_city() { return this.contractForm.get('customer_city'); }
  get customer_address() { return this.contractForm.get('customer_address'); }
  get customer_email() { return this.contractForm.get('customer_email'); }
  get customer_phone() { return this.contractForm.get('customer_phone'); }
  //get agent_id() { return this.contractForm.get('agent_id'); }
  //get agent_name() { return this.contractForm.get('agent_name'); }
  get agent_person_id() { return this.contractForm.get('agent_person_id'); }
  get agent_person_name() { return this.contractForm.get('agent_person_name'); }
  get commission() { return this.contractForm.get('commission'); }
  get status_id() { return this.contractForm.get('status_id'); }
  get status_code() { return this.contractForm.get('status_code'); }
  get payment_code() { return this.contractForm.get('payment_code'); }
  get updated_by() { return this.contractForm.get('updated_by'); }
  get updated_date() { return this.contractForm.get('updated_date'); }
}

//**************************************************************************************************************
// PopUp Email
//**************************************************************************************************************
@Component({
  selector: 'app-popup-email',
  templateUrl: 'popup-email.component.html',
  styleUrls: ['./popup-email.component.css'],
})
export class PopupEmailComponent implements OnInit {
  @ViewChild('editorEmail') emailEditor: jqxEditorComponent;
  @ViewChild('emailAddressCustomer') emailAddressCustomer: jqxRadioButtonComponent;
  @ViewChild('emailAddressAgent') emailAddressAgent: jqxRadioButtonComponent;
  @ViewChild('methodEmail') methodEmail: jqxRadioButtonComponent;
  @ViewChild('methodPhone') methodPhone: jqxRadioButtonComponent;

  emailForm: FormGroup;
  errorMessage: any;
  successMessage: any;
  selectedcell: any;
  delrows: Array<any> = [];
  remindList: Array<any> = [];
  customerNameStr: any;
  agentNameStr: any;
  sendNameStr: any;
  endDateStrJ: any;
  endDateStrE: any;
  startDateStrJ: any;
  startDateStrE: any;
  send_email_address: any;
  customer_email: any;
  method_flg: boolean;
  from_phone: any;
  send_phone: any;
  customer_phone: any;
  agent_email: any;
  sending_flg: boolean;

  //ToolsEmail: string = 'customer | startdate | enddate | font | size | color | bold  italic underline ';
  ToolsEmail: string = 'customer | font | size | color | bold  italic underline ';

  createCommandEmail = (name: string): any => {
    switch (name) {
      //case 'nameOrDatetime':
      //  return {
      //    type: 'list',
      //    tooltip: 'Insert Name or Date',
      //    init: (widget: any): void => {
      //      widget.jqxDropDownList({ placeHolder: 'Insert Name Or Date', width: 170, source: [this.customerNameStr, this.endDateStr], autoDropDownHeight: true });
      //    },
      //    refresh: (widget: any, style: any): void => {
      //       do something here when the selection is changed.
      //      widget.jqxDropDownList('clearSelection');
      //    },
      //    action: (widget: any, editor: any): any => {
      //      let widgetValue = widget.val();
      //       return object with command and value members.
      //      return { command: 'inserthtml', value: widgetValue == 'Name' ? customerName : endDate.getFullYear() + ' /' + endDate.getMonth() + ' /' + endDate.getDate() + ' /' +  };
      //      return { command: 'inserthtml', value: widgetValue == this.customerNameStr ? this.customerNameStr : this.endDateStr };
      //    }
      //  }
      case 'customer':
        return {
          type: 'button',
          tooltip: 'Insert Name',
          init: (widget: any): void => {
            widget.jqxButton({ width: 350 });
            //widget.html('<span style="line-height: 24px;"> ' + this.sendNameStr + ' </span>');
            widget.html('<span style="line-height: 24px;"> Send To </span>');
          },
          refresh: (widget: any, style: any): void => {
            // do something here when the selection is changed.
          },
          action: (widget: any, editor: any): any => {
            return { command: 'inserthtml', value: this.sendNameStr };
          }
        }
      //case 'startdate':
      //  return {
      //    type: 'list',
      //    tooltip: 'Insert Start Date',
      //    init: (widget: any): void => {
      //      widget.jqxDropDownList({ placeHolder: 'Start Date', width: 170, source: [this.startDateStrJ, this.startDateStrE], autoDropDownHeight: true });
      //      //widget.jqxButton({ height: 25 });
      //      //widget.html('<span style="line-height: 24px;">' + this.endDateStrJ + ' </span>');
      //    },
      //    refresh: (widget: any, style: any): void => {
      //      // do something here when the selection is changed.
      //      widget.jqxDropDownList('clearSelection');
      //    },
      //    action: (widget: any, editor: any): any => {
      //      let widgetValue = widget.val();
      //      return { command: 'inserthtml', value: widgetValue == this.startDateStrJ ? this.startDateStrJ : this.startDateStrE };
      //      //return { command: 'inserthtml', value: this.endDateStrJ };
      //    }
      //  }
      //case 'enddate':
      //  return {
      //    type: 'list',
      //    tooltip: 'Insert End Date',
      //    init: (widget: any): void => {
      //      widget.jqxDropDownList({ placeHolder: 'End Date', width: 170, source: [this.endDateStrJ, this.endDateStrE], autoDropDownHeight: true });
      //      //widget.jqxButton({ height: 25 });
      //      //widget.html('<span style="line-height: 24px;">' + this.endDateStrJ + ' </span>');
      //    },
      //    refresh: (widget: any, style: any): void => {
      //      // do something here when the selection is changed.
      //      widget.jqxDropDownList('clearSelection');
      //    },
      //    action: (widget: any, editor: any): any => {
      //      let widgetValue = widget.val();
      //      return { command: 'inserthtml', value: widgetValue == this.endDateStrJ ? this.endDateStrJ : this.endDateStrE };
      //      //return { command: 'inserthtml', value: this.endDateStrJ };
      //    }
      //  }
    }
  };

  //localizationEmail: any = {
  //  'bold': 'Fett',
  //  'italic': 'Kursiv',
  //  'underline': 'Unterstreichen',
  //  'font': 'Schriftname',
  //  'size': 'Schriftgröße',
  //  'color': 'Textfarbe',
  //  'background': 'Hintergrundfarbe',
  //  'clean': 'Formatierung entfernen'
  //};
  constructor(
    public dialogRef: MatDialogRef<PopupEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _contractService: ContractService,
    private _masterService: MasterService,
    //private _moment: MomentModule, private _timezone: MomentTimezoneModule,
    private _fb: FormBuilder, private _com: CommonService
  ) {
    this.sending_flg = false;
    this.method_flg = false;
    let dayNamesJ = this._com.getJPNDayDropDownList();
    let dayNamesE = this._com.getUSADayDropDownList();
    this.sendNameStr = data.customer_name;
    this.customerNameStr = data.customer_name;
    this.customer_email = data.customer_email;
    this.customer_phone = data.customer_phone;

    ////第二弾
    //let sdate = this._com.changeDateTime(data.start_date);
    //this.startDateStrJ = sdate.getFullYear() + ' 年 ' + sdate.getMonth() + ' 月 ' + sdate.getDate() + ' 日 (' + dayNamesJ[sdate.getDay()] + ')';
    //this.startDateStrE = sdate.getMonth() + ' / ' + sdate.getDate() + ' / ' + sdate.getFullYear() + ' (' + dayNamesE[sdate.getDay()] + ')';

    //let edate = this._com.changeDateTime(data.end_date);
    //this.endDateStrJ = edate.getFullYear() + ' 年 ' + edate.getMonth() + ' 月 ' + edate.getDate() + ' 日 (' + dayNamesJ[edate.getDay() ] + ')';
    //this.endDateStrE = edate.getMonth() + ' / ' + edate.getDate() + ' / ' + edate.getFullYear() + ' (' + dayNamesE[edate.getDay()] + ')';

    ////第一弾
    this.endDateStrJ = data.end_date.getFullYear() + ' 年 ' + (data.end_date.getMonth() + 1) + ' 月 ' + data.end_date.getDate() + ' 日 (' + dayNamesJ[data.end_date.getDay()] + ')';
    this.endDateStrE = (data.end_date.getMonth() + 1) + ' / ' + data.end_date.getDate() + ' / ' + data.end_date.getFullYear() + ' (' + dayNamesE[data.end_date.getDay()] + ')';
    this.startDateStrJ = data.start_date.getFullYear() + ' 年 ' + (data.start_date.getMonth() + 1) + ' 月 ' + data.start_date.getDate() + ' 日 (' + dayNamesJ[data.start_date.getDay()] + ')';
    this.startDateStrE = (data.start_date.getMonth() + 1) + ' / ' + data.start_date.getDate() + ' / ' + data.start_date.getFullYear() + ' (' + dayNamesE[data.start_date.getDay()] + ')';

    //Email Address
    this.getAgentEmail(data.agent_id);
    this.send_email_address = data.customer_email;
    this.from_phone = '+12056198773';
    this.send_phone = data.customer_phone;

    ////let sdate = moment(this._com.changeDateTime(data.start_date));
    ////let edate = moment(this._com.changeDateTime(data.end_date));

    //let sdate = this._com.changeDateTimeE(data.start_date);
    //let edate = this._com.changeDateTimeE(data.end_date);

    //this.startDateStrE = sdate.format("MM") + ' / ' + sdate.format("dd") + ' / ' + sdate.format("yyyy") + ' (' + sdate.format("ddd") + ')';
    //this.endDateStrE = edate.format("MM") + ' / ' + edate.format("dd") + ' / ' + edate.format("yyyy") + ' (' + edate.format("ddd") + ')';

    ////moment.locale('ja');
    ////sdate = moment(this._com.changeDateTime(data.start_date));
    ////edate = moment(this._com.changeDateTime(data.end_date));

    //sdate = this._com.changeDateTimeJ(data.start_date);
    //edate = this._com.changeDateTimeJ(data.end_date);

    //this.endDateStrJ = edate.format("yyyy") + ' 年 ' + edate.format("MM") + ' 月 ' + edate.format("dd") + ' 日 (' + edate.format("ddd") + ')';
    //this.startDateStrJ = sdate.format("yyyy") + ' 年 ' + sdate.format("MM") + ' 月 ' + sdate.format("dd") + ' 日 (' + sdate.format("ddd") + ')';

    this.emailForm = this._fb.group({
      remind_id: [null, Validators.required],
      customer_id: data.customer_id,
      customer_name: data.customer_name,
      method_flg: data.method_flg,
      send_email_address: data.customer_email,
      from_phone: this.from_phone,
      send_phone: data.customer_phone,
      start_date: data.start_date,
      end_date: data.end_date,
      email_subject: ['', Validators.required],
      email_contents: ['', Validators.required],
    })
  }

  ngOnInit() {
    this.getRemindDropDown();
  }

  ngAfterViewInit(): void {
    this.emailEditor.createComponent({});
  }

  getAgentEmail(id): void {
    if (id > 0) {
      this._masterService.getAgentPersonById(id)
        .subscribe(
          res => {
            this.agent_email = res.email;
            this.agentNameStr = res.name;
          },
          error => this.errorMessage = error
        );
    } else {
      this.agent_email = "";
    }
  }

  emailOnSelect(event: any): void {
    let value = event.value;
    this.getRemindById(value);
  }

  getRemindById(id) {
    if (id > 0) {
      this._masterService.getRemindById(id)
        .subscribe(
          res => {
            var str = res.email_contents;
            var result = this.remakeContents(str);
            while (result !== str) {
              str = this.remakeContents(str);
              result = this.remakeContents(result);
            }
            this.emailEditor.val(result);
            this.emailForm.controls.email_subject.setValue(res.email_subject);
          },
          error => this.errorMessage = error
        );
    } else {
      this.emailEditor.val('');
      this.emailForm.controls.email_subject.setValue(null);
    }
  }

  remakeContents(contents:string){
    var result = contents.replace('[ParaCustomerName]', this.customerNameStr)
      .replace('[ParaEndDateJ]', this.endDateStrJ)
      .replace('[ParaEndDateE]', this.endDateStrE)
      .replace('[ParaStartDateJ]', this.startDateStrJ)
      .replace('[ParaStartDateE]', this.startDateStrE);
    return result;
  }

  getRemindDropDown() {
    this._masterService.getReminds(true).subscribe((data) => {
      this.remindList = data;
    });
  }

  getWidthEmail(): any {
    return '100%';
  }

  getHeightEmail(): any {
    return '70%';
  }

  //getDayFunc(id) {
  //  switch (id) {
  //    case 1:
  //      return '月';
  //    case 2:
  //      return '火';
  //    case 3:
  //      return '水';
  //    case 4:
  //      return '木';
  //    case 5:
  //      return '金';
  //    case 6:
  //      return '土';
  //    case 7:
  //      return '日';
  //  }
  //}

  //Save Data
  submitEmail() {
    //check form
    //this.emailForm.value.email_contents = this.emailEditor.val();
    this.emailForm.controls.method_flg.setValue(this.method_flg);
    if (!(this.method_flg)) {
      this.emailForm.controls.email_contents.setValue(this.emailEditor.val());
      this.emailForm.controls.send_email_address.setValue(this.send_email_address);
      //this.emailForm.value.email_contents = this.emailEditor.val();
      //console.log(this.emailForm);
      if (this.emailForm.invalid) {
        this.errorMessage = 'Please enter all required fields.';
        return;
      }

      if (this.emailForm.controls.send_email_address == null) {
        this.errorMessage = 'Please set his email on [Customer] screen.';
        return;
      }

      this.errorMessage = null;
      this.successMessage = null;
      this.sending_flg = true;

      if (confirm('Are you sure to send an email?')) {
        var remindId = this.emailForm.value.remind_id;
        this._contractService.sendEmail(this.emailForm.value)
          .subscribe(
            data => {
              //console.log(data);
              if (data.ok == true) {
                console.log("Sent Date: " + new Date());
                this._contractService.updateContractAfterEmail(this.data.contract_period_id, remindId, new Date().toISOString())
                  .subscribe(
                    data => {
                      if (data = 0) {
                        this.successMessage = null;
                        this.errorMessage = "Failed to update the data. ";
                        this.sending_flg = false;
                      }
                    },
                    error => {
                      this.successMessage = null;
                      if (error != null) {
                        this.errorMessage = error._body;
                        this.sending_flg = false;
                      }
                      else {
                        this.errorMessage = "Failed to update the data. ";
                        this.sending_flg = false;
                      }
                    });
                this.successMessage = 'Email has been sent.';
                this.sending_flg = false;
              }
            },
            error => {
              if (error._body != null) {
                this.errorMessage = error._body;
                this.sending_flg = false;
              } else {
                this.errorMessage = error._body;
                this.sending_flg = false;
              }
            });
      }
    } else {
      this.emailForm.controls.email_contents.setValue(this.emailEditor.val());
      //this.emailForm.controls.from_phone.setValue(this.from_phone);
      //this.emailForm.controls.send_phone.setValue(this.send_phone);
      //this.emailForm.value.email_contents = this.emailEditor.val();
      //console.log(this.emailForm);
      if (this.emailForm.invalid) {
        this.errorMessage = 'Please enter all required fields.';
        return;
      }

      if (this.emailForm.controls.send_phone == null) {
        this.errorMessage = 'Please set his phone on [Customer] screen.';
        return;
      }

      this.errorMessage = null;
      this.successMessage = null;
      this.sending_flg = true;

      if (confirm('Are you sure to send text message?')) {
        var remindId = this.emailForm.value.remind_id;
        this._contractService.sendEmail(this.emailForm.value)
          .subscribe(
            data => {
              //console.log(data);
              if (data.ok == true) {
                //20201124 テストより更新されないように一旦コメントアウト
                //console.log("Sent Date: " + new Date());
                //this._contractService.updateContractAfterEmail(this.data.contract_period_id, remindId, new Date().toISOString())
                //  .subscribe(
                //    data => {
                //      if (data = 0) {
                //        this.successMessage = null;
                //        this.errorMessage = "Failed to update the data. ";
                //        this.sending_flg = false;
                //      }
                //    },
                //    error => {
                //      this.successMessage = null;
                //      if (error != null) {
                //        this.errorMessage = error._body;
                //        this.sending_flg = false;
                //      }
                //      else {
                //        this.errorMessage = "Failed to update the data. ";
                //        this.sending_flg = false;
                //      }
                //    });
                this.successMessage = 'Email has been sent.';
                this.sending_flg = false;
              }
            },
            error => {
              if (error._body != null) {
                this.errorMessage = error._body;
                this.sending_flg = false;
              } else {
                this.errorMessage = error._body;
                this.sending_flg = false;
              }
            });
      }
    }
  }

  //Target Month status
  methodEmailBtnOnClick(event: any): void {
    this.method_flg = false;
  }

  methodPhoneBtnOnClick(event: any): void {
    this.method_flg = true;
  }
  emailAgentBtnOnClick(event: any): void {
    this.send_email_address = this.agent_email;
    this.emailForm.controls.customer_name.setValue(this.agentNameStr);
    this.sendNameStr = this.agentNameStr;
  }
  emailBothBtnOnClick(event: any): void {
    this.send_email_address = this.customer_email + "; " + this.agent_email;
    this.emailForm.controls.customer_name.setValue(this.customerNameStr + ", " + this.agentNameStr );
    this.sendNameStr = this.customerNameStr + ", " + this.agentNameStr;
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }

  //get remind_id() { return this.emailForm.get('remind_id'); }
  //get customer_name() { return this.emailForm.get('customer_name'); }
  //get start_date() { return this.emailForm.get('start_date'); }
  //get end_date() { return this.emailForm.get('end_date'); }
  //get email_contents() { return this.emailForm.get('email_contents'); }

}



// WEBPACK FOOTER //
// ./src/app/contract/contract-list.component.ts